/* =====================================================================
   FLÉORA — site script
   Everything the team is likely to edit lives at the top:
   CONFIG, PHOTOS, PRODUCTS, BUNDLES, INGREDIENTS, FAQS and POLICIES.
   ===================================================================== */
const IMG = window.FLEORA_IMG || {};

const CONFIG = {
  preview: true,                   // true shows the "Team notes" button in the footer. Set to false before go-live.
  brand: "Fléora",
  company: "Powerlabs Healthcare Pvt. Ltd.",

  /* ---- contact (confirm these before go-live) ---- */
  email: "support@fleora.com",
  whatsapp: "918452030868",        // digits only, with country code. Orders and messages open a chat with this number. "" switches WhatsApp off.
  whatsappShown: "+91 84520 30868",
  instagram: "",                   // full Instagram URL. Empty hides the link.

  /* ---- connections (all optional; the site works without them) ---- */
  razorpayKey: "",                 // Razorpay Key ID (rzp_live_...). When set, "Pay online" opens Razorpay Checkout.
  orderEndpoint: "",               // URL that receives each order as JSON (Google Apps Script, Make, Zapier, your own API).
  formEndpoint: "",                // URL that receives contact-form messages as JSON.
  newsletterEndpoint: "",          // URL that receives newsletter sign-ups as JSON.

  /* ---- offers and shipping (placeholders: confirm) ---- */
  freeShipAt: 699,                 // free shipping threshold (₹)
  shipFee: 49,                     // shipping below the threshold (₹)
  coupon: { code: "BLOOM10", pct: 10 },
  prepaidPct: 5,                   // extra off for online payment
  dispatch: "within 2 working days",
  delivery: "3 to 7 working days",

  heroSeconds: 6.5,
  announcements: [
    "Launch offer: <b>10% off</b> your first order with code <b>BLOOM10</b>",
    "Free shipping on orders above <b>₹699</b>",
    "Extra <b>5% off</b> when you pay online",
    "Save <b>15%</b> on The Full Ritual set"
  ]
};

/* ---- Shopify: values set in Theme settings replace the defaults above ---- */
const SHOP = window.FLEORA_SHOPIFY || null;
if (SHOP && SHOP.config) Object.keys(SHOP.config).forEach(k => {
  const v = SHOP.config[k];
  if (v === null || v === undefined || (Array.isArray(v) && !v.length)) return;
  CONFIG[k] = v;
});
const shopRoot = SHOP ? String(SHOP.root || "/").replace(/\/?$/, "/") : "/";

/* Lifestyle photographs. Fléora's own model pictures, made in Higgsfield from the real product shots
   and stored inside this file (the "life..." entries in IMG).
   To use a hosted picture instead, save it into assets/img/life/ and add
   file: "assets/img/life/your-file.jpg"  to its line. That takes priority over the built-in one.
   If a picture cannot load, the site shows a product composition in its place. */
const PHOTOS = {
  mistOn:    { img: "lifeMistOn",    alt: "A woman misting Fléora Sunscreen Mist onto her face beside a sunlit window" },
  mistAlt:   { img: "lifeMistAlt",   alt: "A smiling woman holding Fléora Sunscreen Mist beside her cheek outdoors" },
  lotionOn:  { img: "lifeLotionOn",  alt: "A woman smoothing Fléora Hydration Lotion onto her arm, holding the bottle" },
  lotionAlt: { img: "lifeLotionAlt", alt: "Close-up of a smiling woman holding the Fléora Hydration Lotion bottle" },
  lipCherry: { img: "lifeLipCherry", alt: "A woman applying Fléora tinted lip balm in Cherry Red" },
  lipMauve:  { img: "lifeLipMauve",  alt: "A woman applying Fléora tinted lip balm in Mauve" }
};

const PRODUCTS = [
  {
    id:"sunscreen-mist", cat:"sun", tone:"lav", img:"mist", gallery:["gMist","gMistBox"],
    name:"Rice Water Sunscreen Mist", short:"Sunscreen Mist",
    tagline:"Weightless, all-day sun protection",
    spf:"SPF 50 PA++++", size:"100 ml", flag:"New launch",
    price:599, mrp:999,
    badges:["SPF 50 PA++++","No White Cast","Lightweight Mist","Rice Water & Vitamin C","Niacinamide","Reapplication-Friendly"],
    desc:"A featherlight, no-white-cast sunscreen mist that mists on in seconds and disappears into skin. Powered by a broad-spectrum UV filter system and finished with rice water, sunflower seed oil and vitamin C for a soft, dewy glow — not a greasy one.",
    benefits:[
      "Broad-spectrum SPF 50 PA++++ protection against UVA & UVB rays",
      "Mist-on formula — ideal for quick reapplication over makeup",
      "Rice water and sunflower seed oil soothe and soften skin",
      "Vitamin C and niacinamide help support an even, bright-looking tone",
      "Fast-absorbing, non-greasy, no white cast"],
    howToUse:["Shake well.","Hold 4–6 inches from the face and mist evenly, or spray onto palms and pat over face and body.","Reapply every 2–3 hours when in the sun."],
    ingredients:"Aqua, Suncate-DE (Water, Ethylhexyl Methoxycinnamate, Butyl Methoxydibenzoylmethane, Benzophenone-3, Butylene Glycol, Phospholipids, and Phenoxyethanol), Caprylic/Capric Triglyceride, Isopropyl Myristate, PEG-40 Hydrogenated Castor Oil, C12-15 Alkyl Benzoate, Zinc Oxide, Titanium Dioxide, Glycerin, Helianthus Annuus (Sunflower) Seed Oil, Rice Water, Cetyl Alcohol, Propylene Glycol, Phenoxyethanol (and) Ethylhexylglycerin, Vitamin C, Moringa Extract, Niacinamide, PEG-165 Distearate, Tocopherol (Vitamin E), Triethanolamine, CM-1000, Fragrance, Acrylates/C10-30 Alkyl Acrylate Crosspolymer.",
    maker:"Manufactured by Radius Wellness Pvt. Ltd. Marketed by Powerlabs Healthcare Pvt. Ltd."
  },
  {
    id:"hydration-lotion", cat:"hydration", tone:"blossom", img:"lotion", gallery:["gLotion","gHydra"],
    name:"Ceramide Hydrating Lotion", short:"Hydrating Lotion",
    tagline:"Daily moisture with sun protection built in",
    spf:"SPF 30 PA+++", size:"200 ml", flag:"New launch",
    price:649, mrp:1099,
    badges:["SPF 30 PA+++","5x Hyaluronic Acid Complex","Ceramide Barrier Complex","Niacinamide","Squalane","Non-Greasy Finish"],
    desc:"A rich yet fast-absorbing daily lotion that layers a ceramide complex, hyaluronic acid and squalane with broad-spectrum SPF 30 — built to lock in moisture while shielding skin from daily sun exposure. One step, done.",
    benefits:[
      "Broad-spectrum SPF 30 PA+++ sun protection in a daily-wear lotion",
      "Ceramide NP, AP & EOP complex with phytosphingosine and cholesterol to support the skin barrier",
      "A five-type hyaluronic acid complex plus coconut water and betaine for deep, lasting hydration",
      "Niacinamide and panthenol (Vitamin B5) to soothe and support skin comfort",
      "Lightweight, quick-absorbing — layers easily under makeup"],
    howToUse:["Apply generously as the last step of your morning routine, over the face, neck and any exposed skin.","Reapply every 2–3 hours when in direct sun."],
    ingredients:"Purified Water, Aqua (and) C12-15 Alkyl Benzoate (and) Diethylamino Hydroxybenzoyl Hexyl Benzoate (and) Ethylhexyl Triazone (and) Bis-Ethylhexyloxyphenol Methoxyphenyl Triazine (and) Phospholipids (and) Polysorbate 80 (and) Butylene Glycol (and) Phenoxyethanol, Propanediol, Dimethyl Isosorbide, Caprylic/Capric Triglyceride, Glycerin, Niacinamide, Squalane, Xylitol, Glycerin, Betaine, Maltitol, Trehalose, Hyaluronic Acid, Opuntia Ficus-Indica Extract, Olive Oil PEG-7 Esters, Coconut Water, Cetearyl Olivate and Sorbitan Olivate, Sodium PCA, Phenoxyethanol and Ethylhexylglycerin, Ceramide NP (and) Ceramide AP (and) Ceramide EOP (and) Phytosphingosine (and) Cholesterol (and) Sodium Lauroyl Lactylate (and) Carbomer (and) Xanthan Gum (and) Water (and) Phenoxyethanol (and) Ethylhexylglycerin, Panthenol (Vitamin B5), Allantoin, Polyacrylate Crosspolymer-6, Perfume, Tocopheryl Acetate, Hyaluronic Acid Sodium Hyaluronate Crosspolymer, Sodium Hyaluronate, Hyaluronic Acid, Potassium Hyaluronate, Sodium Acetylated Hyaluronate, Hydrolyzed Sodium Hyaluronate, Tremella Fuciformis Polysaccharides, Sodium Polyglutamate, Pentylene Glycol, Ethylhexylglycerin, Aqua, Disodium EDTA.",
    maker:"Manufactured by Lab For Youth Pvt. Ltd., Panchkula, Haryana. Marketed by Powerlabs Healthcare Pvt. Ltd."
  },
  {
    id:"lip-balm-cherry", cat:"lips", tone:"cherry", img:"lipCherry", gallery:[],
    name:"Tinted Kojic Lip Balm — Cherry Red", short:"Lip Balm, Cherry Red",
    tagline:"A juicy cherry-red wash, built to nourish",
    spf:"SPF 50", size:"", flag:"New launch",
    shade:{name:"Cherry Red", color:"var(--cherry)"}, sibling:"lip-balm-mauve",
    price:399, mrp:599,
    badges:["SPF 50","Tinted — Cherry Red","Shea & Cocoa Butter","Kojic Acid","Ceramide Complex","Rose Oil"],
    desc:"A nourishing tinted balm in a juicy cherry-red wash, built on a butter-rich base of shea, cocoa and kokum, with SPF 50 protection and Kojic acid to help fade dryness-related dullness. A wash of colour and a dose of care, in one swipe.",
    benefits:[
      "SPF 50 protection for often-forgotten, delicate lip skin",
      "Rich blend of shea butter, cocoa butter, kokum butter and mango butter for deep nourishment",
      "Kojic acid dipalmitate and licorice extract to help brighten and even lip tone",
      "A 5-Ceramide complex to support and restore the lip barrier",
      "Sheer, buildable cherry-red tint with a soft rose-oil finish"],
    howToUse:["Swipe directly onto lips as needed throughout the day.","Layer for more colour payoff.","Reapply after eating, drinking or sun exposure."],
    ingredients:"Beeswax, Cocos Nucifera (Coconut) Oil, Microcrystalline Wax, White Soft Paraffin, Dimethicone/Vinyl Dimethicone Crosspolymer, Isopropyl Myristate, Paraffin Wax, Suncate-DE (Water, Ethylhexyl Methoxycinnamate, Butyl Methoxydibenzoylmethane, Benzophenone-3, Butylene Glycol, Phospholipids, and Phenoxyethanol), Theobroma Cacao (Cocoa) Butter, Garcinia Indica (Kokum) Seed Butter, Butyrospermum Parkii (Shea Butter), Pigment, Cera Alba (Beeswax), Caprylic/Capric Triglyceride, C12-15 Alkyl Benzoate, Rose Oil, Isododecane, Dimethicone Crosspolymer, Mangifera Indica (Mango) Butter, Kojic Acid Dipalmitate, Licorice Extract, Rosmarinus Officinalis (Rosemary) Extract, Copernicia Cerifera (Carnauba Wax), Ceramide Complex (Ceramide 1, Ceramide 2, Ceramide 3, Ceramide 4, Ceramide 6-II, 1,2-Hexanediol), SabiWhite®, Tocopherol (Vitamin E), Phenoxyethanol.",
    maker:"Manufactured by Radius Wellness Pvt. Ltd. Marketed by Powerlabs Healthcare Pvt. Ltd."
  },
  {
    id:"lip-balm-mauve", cat:"lips", tone:"mauve", img:"lipMauve", gallery:[],
    name:"Tinted Kojic Lip Balm — Mauve", short:"Lip Balm, Mauve",
    tagline:"A soft, your-lips-but-better mauve wash",
    spf:"SPF 50", size:"", flag:"New launch",
    shade:{name:"Mauve", color:"var(--mauve)"}, sibling:"lip-balm-cherry",
    price:399, mrp:599,
    badges:["SPF 50","Tinted — Mauve","Shea & Kokum Butter","Kojic Acid","Ceramide Complex","Rose Oil"],
    desc:"The dusty-rose sister to our Cherry Red balm — a soft, your-lips-but-better mauve wash in the same nourishing, SPF 50 butter base. Understated colour, full-on care.",
    benefits:[
      "SPF 50 protection in a soft, everyday mauve tint",
      "Kokum seed butter and shea butter for a cushiony, non-drying feel",
      "Kojic acid dipalmitate and licorice extract to help brighten lip tone",
      "A 5-Ceramide complex to strengthen the lip's natural barrier",
      "Silica-smoothed texture for a soft-focus, blurred finish"],
    howToUse:["Apply directly to lips whenever they need a little colour and comfort.","Layer to build depth.","Reapply through the day, especially after sun exposure."],
    ingredients:"Beeswax, Cocos Nucifera (Coconut) Oil, Microcrystalline Wax, Dimethicone/Vinyl Dimethicone Crosspolymer, Color, Isododecane, Suncate-DE (Water, Ethylhexyl Methoxycinnamate, Butyl Methoxydibenzoylmethane, Benzophenone-3, Butylene Glycol, Phospholipids, and Phenoxyethanol), Garcinia Indica (Kokum) Seed Butter, Butyrospermum Parkii (Shea Butter), White Soft Paraffin, Paraffin Wax, Theobroma Cacao (Cocoa) Butter, Dimethicone Crosspolymer, Rose Oil, Cera Alba (Beeswax), C12-15 Alkyl Benzoate, Silica, Rosmarinus Officinalis (Rosemary) Extract, Mangifera Indica (Mango) Butter, Kojic Acid Dipalmitate, Licorice Extract, Copernicia Cerifera (Carnauba Wax), Ceramide Complex (Ceramide 1, Ceramide 2, Ceramide 3, Ceramide 4, Ceramide 6-II, 1,2-Hexanediol), SabiWhite®, Tocopherol (Vitamin E), Phenoxyethanol.",
    maker:"Manufactured by Radius Wellness Pvt. Ltd. Marketed by Powerlabs Healthcare Pvt. Ltd."
  }
];

const BUNDLES = [
  { id:"bundle-duo",    name:"The Morning Duo", items:["hydration-lotion","sunscreen-mist"], pct:10, tone:"mix",
    line:"Hydrate, then protect. The two-step morning." },
  { id:"bundle-lips",   name:"The Lip Pair",    items:["lip-balm-cherry","lip-balm-mauve"],  pct:10, tone:"cherry",
    line:"Both shades, one for each mood." },
  { id:"bundle-ritual", name:"The Full Ritual", items:["hydration-lotion","sunscreen-mist","lip-balm-cherry","lip-balm-mauve"], pct:15, tone:"lav",
    line:"All four essentials, from face to lips." }
];

const INGREDIENTS = [
  { id:"spf", name:"Broad-spectrum SPF filters", role:"Shields from UVA and UVB", icon:"i-sun",
    body:"Our sunscreen mist and lotion use a broad-spectrum UV filter system that shields skin from both UVA and UVB rays — the two types of sun exposure linked to premature ageing and sunburn. The lip balms carry SPF 50 too, because lips burn as easily as skin.",
    products:["sunscreen-mist","hydration-lotion","lip-balm-cherry","lip-balm-mauve"] },
  { id:"ceramides", name:"Ceramides", role:"Support the skin barrier", icon:"i-shield",
    body:"Naturally occurring lipids that make up part of your skin's outer barrier. Our Hydrating Lotion uses a ceramide complex with phytosphingosine and cholesterol to help that barrier stay strong, and the lip balms carry a 5-ceramide complex for the lip barrier.",
    products:["hydration-lotion","lip-balm-cherry","lip-balm-mauve"] },
  { id:"ha", name:"Hyaluronic acid", role:"Draws in and holds moisture", icon:"i-drop",
    body:"A humectant that pulls water into the skin and holds it there. Our lotion uses a five-type complex, layered with coconut water and betaine, for hydration that lasts through the day.",
    products:["hydration-lotion"] },
  { id:"niacinamide", name:"Niacinamide", role:"Evens texture and tone", icon:"i-blossom",
    body:"Vitamin B3. Used in the mist and the lotion to help support skin's texture and tone, calm the look of redness, and work quietly alongside our other actives.",
    products:["sunscreen-mist","hydration-lotion"] },
  { id:"kojic", name:"Kojic acid", role:"Brightens lip tone", icon:"i-lips",
    body:"Found in our tinted lip balms. Kojic acid dipalmitate, paired with licorice extract, helps fade dryness-related dullness so lip colour looks even and fresh.",
    products:["lip-balm-cherry","lip-balm-mauve"] },
  { id:"rice", name:"Rice water and botanicals", role:"Soothe and soften", icon:"i-blossom",
    body:"Rice water, moringa extract and sunflower seed oil round out the sunscreen mist with softening, soothing botanical support — the finishing touch after the actives do their job.",
    products:["sunscreen-mist"] },
  { id:"vitc", name:"Vitamin C", role:"For a bright-looking tone", icon:"i-sun",
    body:"An antioxidant that helps support an even, bright-looking tone. In the mist it works with niacinamide, so your sun protection leaves a soft glow behind.",
    products:["sunscreen-mist"] },
  { id:"butters", name:"Shea, cocoa and kokum butters", role:"Deep nourishment for lips", icon:"i-heart",
    body:"The butter-rich base of both lip balms. Shea, cocoa, kokum and mango butters give a cushiony, non-drying feel, finished with a little rose oil.",
    products:["lip-balm-cherry","lip-balm-mauve"] }
];

const RITUAL = [
  { id:"hydration-lotion", title:"Nourish", text:"Smooth the Ceramide Hydrating Lotion over face, neck and any exposed skin." },
  { id:"sunscreen-mist",   title:"Protect", text:"Hold the Sunscreen Mist 4–6 inches away and mist evenly. Reapply every 2–3 hours in the sun." },
  { id:"lip-balm-cherry",  title:"Glow",    text:"Swipe on a Tinted Lip Balm. Layer it for more colour." }
];

const FAQS = [
  { q:"Is Fléora suitable for all skin types?", a:"Yes. Every product in the range is formulated and labelled for all skin types, and is dermatologically tested before release.", home:true },
  { q:"Will the sunscreen leave a white cast?", a:"No. The Rice Water Sunscreen Mist is formulated to be lightweight and fast-absorbing with no white cast, and it can be reapplied over makeup.", home:true },
  { q:"Can I use the Hydrating Lotion and Sunscreen Mist together?", a:"Yes. Apply the Hydrating Lotion as your last skincare step, then follow with the Sunscreen Mist. On lower-sun days you can use the lotion alone, since it carries SPF 30.", home:true },
  { q:"How long does shipping take?", a:"We ship pan-India. Orders are dispatched within 2 working days and usually arrive in 3 to 7 working days.", home:true },
  { q:"Are your products cruelty-free?", a:"Yes, our formulas are developed cruelty-free." },
  { q:"What payment methods do you accept?", a:"UPI, major cards, net banking and cash on delivery." },
  { q:"Can I return a product?", a:"Unopened products may be returned within 7 days of delivery. Use the form on this page and we'll help." }
];

/* the routine steps can be edited in the theme editor (Morning routine section) */
function readJSON(id){ const el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch(e){ return null; } }
function syncRitual(){
  const steps = (readJSON("ritualData") || []).filter(s => s && PRODUCTS.some(p => p.id === s.id) && s.title);
  if (steps.length) RITUAL.splice(0, RITUAL.length, ...steps);
}

/* extras layered onto the product data above */
Object.assign(PRODUCTS.find(p => p.id === "sunscreen-mist"),   { life: "mistOn" });
Object.assign(PRODUCTS.find(p => p.id === "hydration-lotion"), { life: "lotionOn" });
Object.assign(PRODUCTS.find(p => p.id === "lip-balm-cherry"),  { life: "lipCherry", size: "4 g" });
Object.assign(PRODUCTS.find(p => p.id === "lip-balm-mauve"),   { life: "lipMauve", size: "4 g" });
const RITUAL_PHOTO = { "hydration-lotion": "lotionAlt", "sunscreen-mist": "mistAlt", "lip-balm-cherry": "lipCherry" };

const LOOKS = [
  { photo: "mistOn",   pid: "sunscreen-mist" },
  { img: "gMist",      label: "Sunscreen Mist" },
  { photo: "lotionOn", pid: "hydration-lotion" },
  { img: "gLotion",    label: "Hydration Lotion" },
  { photo: "lipMauve", pid: "lip-balm-mauve" },
  { img: "gMistBox",   label: "Mist and carton" },
  { img: "gHydra",     label: "On the shelf" }
];

const STATES = ["Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Andaman and Nicobar Islands","Chandigarh","Dadra and Nagar Haveli and Daman and Diu","Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry"];

const POLICIES = {
  shipping: { title: "Shipping", lead: "Where we deliver, how long it takes and what it costs.", body: () => `
    <h2>Where we ship</h2>
    <p>We deliver across India. Every order is packed by us and handed to a courier partner, and you get a tracking link by message once it's on its way.</p>
    <h2>How long it takes</h2>
    <ul><li>Orders are dispatched ${CONFIG.dispatch}.</li><li>Delivery usually takes ${CONFIG.delivery} after dispatch, depending on your pincode.</li><li>Orders placed on Sundays and public holidays are dispatched on the next working day.</li></ul>
    <h2>What it costs</h2>
    <ul><li>Shipping is free on orders above ${money(CONFIG.freeShipAt)}.</li><li>Orders below that carry a flat ${money(CONFIG.shipFee)} shipping fee, shown before you pay.</li><li>Cash on delivery is available at no extra charge.</li></ul>
    <h2>If something goes wrong</h2>
    <p>If your parcel arrives damaged, or tracking hasn't moved for five days, message us with your order number and we'll sort it out. See <a class="link" href="#/policy/returns">Returns and refunds</a>.</p>` },
  returns: { title: "Returns and refunds", lead: "What you can send back, and how refunds work.", body: () => `
    <h2>Returns</h2>
    <ul><li>Unopened products may be returned within 7 days of delivery.</li><li>For hygiene reasons we can't take back products that have been opened or used.</li><li>To start a return, message us with your order number. We'll arrange the pickup or share the return address.</li></ul>
    <h2>Damaged or wrong items</h2>
    <p>If an item arrives damaged, leaking or different from what you ordered, tell us within 48 hours of delivery and include a photo. We'll send a replacement or refund you in full, whichever you prefer.</p>
    <h2>Refunds</h2>
    <ul><li>Refunds go back to the original payment method within 7 to 10 working days of us receiving the return.</li><li>Cash on delivery orders are refunded by UPI or bank transfer.</li><li>Shipping fees are refunded when the return is due to our error.</li></ul>
    <h2>Cancellations</h2>
    <p>You can cancel an order any time before it is dispatched. Message us with your order number and we'll cancel it and refund any payment.</p>` },
  privacy: { title: "Privacy", lead: "What we collect, why, and the choices you have.", body: () => `
    <h2>What we collect</h2>
    <ul><li>Your name, phone number, email and delivery address, when you place an order or contact us.</li><li>The items you order and how you chose to pay.</li><li>Your email address, if you join our mailing list.</li></ul>
    <p>We never see or store your card, UPI or bank details. Online payments are handled by our payment partner.</p>
    <h2>How we use it</h2>
    <ul><li>To deliver your order and keep you updated about it.</li><li>To answer your questions and handle returns.</li><li>To send news and offers, only if you signed up for them. You can unsubscribe at any time.</li></ul>
    <h2>Who we share it with</h2>
    <p>Only the partners needed to fulfil your order: our courier and payment partners. We do not sell your information.</p>
    <h2>On this device</h2>
    <p>Your bag, saved items and saved delivery details are stored in your own browser so the site remembers them. Clearing your browser data removes them.</p>
    <h2>Your choices</h2>
    <p>You can ask us for a copy of your information, or ask us to correct or delete it, by writing to <a class="link" href="mailto:${CONFIG.email}">${CONFIG.email}</a>.</p>` },
  terms: { title: "Terms of use", lead: "The basics of buying from Fléora.", body: () => `
    <h2>About us</h2>
    <p>This website is run by ${CONFIG.company}, which markets the Fléora range. By placing an order you agree to these terms.</p>
    <h2>Products</h2>
    <ul><li>Our products are cosmetics for external use only. They are not medicines and are not meant to diagnose, treat or cure any condition.</li><li>Do a patch test before first use. Stop using a product and speak to a doctor if irritation occurs.</li><li>Colours can look slightly different on different screens.</li></ul>
    <h2>Prices and orders</h2>
    <ul><li>All prices are in Indian rupees and include applicable taxes.</li><li>An order is confirmed once we send you a confirmation message. We may cancel an order if a product is out of stock or a price was listed in error, and we'll refund any payment in full.</li><li>Discount codes can't be combined unless we say so, and can be withdrawn at any time.</li></ul>
    <h2>Shipping and returns</h2>
    <p>See our <a class="link" href="#/policy/shipping">Shipping</a> and <a class="link" href="#/policy/returns">Returns and refunds</a> pages.</p>
    <h2>Contact</h2>
    <p>Questions about these terms: <a class="link" href="mailto:${CONFIG.email}">${CONFIG.email}</a>. These terms are governed by the laws of India.</p>` }
};

const TEAM_NOTES = [
  "<b>Contact details.</b> The WhatsApp number (" + CONFIG.whatsappShown + ") and email (" + CONFIG.email + ") were copied from your trial site. Orders and messages open a WhatsApp chat with that number, so confirm it is yours. Both are in CONFIG at the top of the script.",
  "<b>Order flow.</b> Right now “Place order” saves the order on the customer's device and opens WhatsApp with the full order written out. Add a Razorpay Key ID in CONFIG.razorpayKey to take online payments on the site, and CONFIG.orderEndpoint to log every order to a sheet. The Razorpay step has not been tested with a live key.",
  "<b>Lifestyle photographs</b> are now Fléora's own model pictures, generated in Higgsfield from the real product shots and built into this file. The stock Pexels models are gone. They are AI-generated: the brand name and main product lines are correct, but the small print on the mist and lotion labels is not accurate when zoomed in. The second lotion picture is a closer crop of the first one. Swap any picture in PHOTOS at the top of the script.",
  "<b>Prices and offers are placeholders</b>: ₹599/₹999, ₹649/₹1,099, ₹399/₹599, code BLOOM10, free shipping above ₹699, ₹49 below it, 5% off online payment, bundle savings of 10–15%. Edit them in CONFIG, PRODUCTS and BUNDLES.",
  "<b>Policies</b> (shipping, returns, privacy, terms) are written from what you've told us plus common practice: dispatch " + CONFIG.dispatch + ", delivery in " + CONFIG.delivery + ", refunds in 7 to 10 working days. Have them checked before go-live.",
  "<b>Net quantity.</b> Lip balm is listed as 4 g from the manufacturer quote. Confirm net quantity, MRP and batch details on each product page against the printed pack, as Legal Metrology requires.",
  "<b>Trust claims</b> (dermatologically tested, cruelty-free, made in India) need confirmation before publishing.",
  "<b>Lotion name.</b> The brief says “Ceramide Hydrating Lotion SPF 30 PA+++”; the artwork shows “Hydration Lotion” and “Hydra-Guard Daily SPF 30 Emulsion”. Pick one. The posters in “A closer look” also say 8 types of hyaluronic acid where the copy says 5.",
  "<b>Cherry Red lip balm photo</b> is a recoloured Mauve photo. Replace it with a real product shot.",
  "<b>Reviews</b> stay empty until real verified reviews exist. <b>Newsletter</b> shows the welcome code but only collects emails once CONFIG.newsletterEndpoint is set. <b>Instagram</b> link appears once CONFIG.instagram is set.",
  "<b>Before go-live:</b> set CONFIG.preview to false to hide this button."
];

/* ---------- helpers ---------- */
const $  = (s, r=document) => r.querySelector(s);
const $$ = (s, r=document) => [...r.querySelectorAll(s)];
const money = n => "₹" + Math.round(n).toLocaleString("en-IN");
const off = p => Math.round((1 - p.price / p.mrp) * 100);
const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;" }[c]));
const icon = (id, cls="") => `<svg class="icon ${cls}" aria-hidden="true"><use href="#${id}"/></svg>`;
const P = id => PRODUCTS.find(p => p.id === id) || PRODUCTS.find(p => p.handle && p.handle === id);
const plain = html => { const t = document.createElement("textarea"); t.innerHTML = html; return t.value; };

/* ---- Shopify: names, prices, stock and checkout ids come from the store.
   A store product is matched to a product or set here by its handle (sunscreen-mist, bundle-duo ...)
   or, failing that, by having exactly the same title. ---- */
const shopFind = it => {
  if (!SHOP) return null;
  const name = String(it.name).trim().toLowerCase();
  return SHOP.products.find(s => s.handle === it.id) || SHOP.products.find(s => String(s.title).trim().toLowerCase() === name) || null;
};
if (SHOP) {
  const taken = new Set();
  PRODUCTS.forEach(p => {
    const s = shopFind(p); if (!s) return;
    taken.add(s.handle);
    Object.assign(p, { handle: s.handle, variantId: s.variantId, available: s.available, price: s.price, mrp: s.compareAt > s.price ? s.compareAt : s.price, name: esc(s.title) });
    if (s.description) p.desc = esc(s.description);
  });
  BUNDLES.forEach(b => { const s = shopFind(b); if (s) taken.add(s.handle); });
  /* any other product in the store gets a simple page of its own */
  SHOP.products.forEach(s => {
    if (taken.has(s.handle)) return;
    const key = "shop:" + s.handle, type = String(s.type || "").toLowerCase();
    if (s.image) IMG[key] = s.image;
    const gallery = (s.images || []).slice(1, 4).map((u, i) => { IMG[key + ":" + i] = u; return key + ":" + i; });
    const text = String(s.description || "");
    PRODUCTS.push({
      id: s.handle, handle: s.handle, variantId: s.variantId, available: s.available, generic: true,
      cat: /sun|spf/.test(type) ? "sun" : /lip/.test(type) ? "lips" : /lotion|hydrat|moistur/.test(type) ? "hydration" : "more",
      tone: "lav", img: key, gallery,
      name: esc(s.title), short: esc(s.title), tagline: esc((text.match(/^[^.!?]*[.!?]?/) || [""])[0].slice(0, 90)),
      spf: esc(s.type || "New"), size: "", flag: "New",
      price: s.price, mrp: s.compareAt > s.price ? s.compareAt : s.price,
      badges: (s.tags || []).slice(0, 6).map(esc), desc: esc(text), benefits: [], howToUse: [], ingredients: "", maker: ""
    });
  });
}

BUNDLES.forEach(b => {
  b.mrp = b.items.reduce((s, id) => s + P(id).price, 0);
  b.price = Math.round(b.mrp * (1 - b.pct / 100));
  const s = shopFind(b); if (!s) return;
  Object.assign(b, { handle: s.handle, variantId: s.variantId, available: s.available, price: s.price, name: esc(s.title) });
  if (s.compareAt > s.price) b.mrp = s.compareAt;
  if (b.mrp > b.price) b.pct = Math.round((1 - b.price / b.mrp) * 100); else { b.mrp = b.price; b.pct = 0; }
});
const B = id => BUNDLES.find(b => b.id === id) || BUNDLES.find(b => b.handle && b.handle === id);
const item = id => P(id) || B(id);
const CATS = [["all","All"],["sun","Sun care"],["hydration","Hydration"],["lips","Lips"]];
const reduced = matchMedia("(prefers-reduced-motion:reduce)").matches;
const canHover = matchMedia("(hover:hover) and (pointer:fine)").matches;
const store = {
  get(k, d){ try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch(e){ return d; } },
  set(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} }
};
const wa = text => CONFIG.whatsapp ? `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(text)}` : "";
const post = (url, data) => url ? fetch(url, { method:"POST", mode:"no-cors", headers:{ "Content-Type":"text/plain" }, body: JSON.stringify(data) }).catch(() => {}) : Promise.resolve();

const pic = (key, alt="", attrs="") => `<img src="${IMG[key] || ""}" alt="${alt}" ${attrs}>`;
function photoSrc(key, w=800, h=1000){
  const p = PHOTOS[key]; if (!p) return "";
  return p.file || IMG[p.img] || "";
}
function photo(key, cls="", w=800, h=1000, onfail="this.remove()"){
  const p = PHOTOS[key]; if (!p) return "";
  return `<img class="ph ${cls}" src="${photoSrc(key, w, h)}" alt="${p.alt}" loading="lazy" decoding="async" referrerpolicy="no-referrer" draggable="false" onload="this.classList.add('is-ok')" onerror="${onfail}">`;
}

/* ---------- saved state ---------- */
let cart = store.get("fleora_cart", {}) || {};
let couponOn = !!store.get("fleora_coupon", false);
let wish = new Set(store.get("fleora_wish", []));
Object.keys(cart).forEach(id => { if (!item(id)) delete cart[id]; });
const saveCart = () => { store.set("fleora_cart", cart); store.set("fleora_coupon", couponOn); };

/* ---------- templates ---------- */
function priceHTML(p){
  if (!(p.mrp > p.price)) return `<b>${money(p.price)}</b>`;
  return `<b>${money(p.price)}</b><s><span class="sr">Was </span>${money(p.mrp)}</s><em>${p.pct ? "Save " + p.pct + "%" : off(p) + "% off"}</em>`;
}
function cardHTML(p){
  const sw = p.shade ? `<div class="shades small">${[p, P(p.sibling)].sort((a,b)=>a.id<b.id?-1:1).map(s =>
    `<a class="shade shade-sm ${s.id===p.id?"is-on":""}" style="--c:${s.shade.color}" href="#/product/${s.id}" aria-label="${s.shade.name}${s.id===p.id?" (this shade)":""}"></a>`).join("")}<span class="muted">${p.shade.name}</span></div>` : "";
  return `
  <article class="pcard tone-${p.tone}">
    <div style="position:relative">
      <a class="pcard-win" href="#/product/${p.id}" aria-label="${p.name}">
        ${pic(p.img, "", p.shade ? 'style="height:64%;margin-bottom:26px"' : "")}
        ${canHover && p.life ? photo(p.life, "pcard-alt", 560, 700) : ""}
      </a>
      <button class="iconbtn pcard-wish" data-wish="${p.id}" aria-pressed="${wish.has(p.id)}" aria-label="Save ${p.name} for later">${icon("i-heart")}</button>
      <button class="iconbtn pcard-quick" data-quick="${p.id}" aria-label="Quick view: ${p.name}">${icon("i-eye")}</button>
    </div>
    <div class="pcard-body">
      <div class="pcard-meta"><span class="chip">${p.spf}</span><span class="chip chip-new">${p.flag}</span>${p.size ? `<span>${p.size}</span>` : ""}</div>
      <h3><a href="#/product/${p.id}">${p.name}</a></h3>
      <p class="pcard-tag">${p.tagline}</p>
      ${sw}
      <div class="price">${priceHTML(p)}</div>
      <button class="btn btn-coral btn-block" data-add="${p.id}">${p.available === false ? "Sold out" : "Add to bag"}</button>
    </div>
  </article>`;
}
function bundleHTML(b){
  return `
  <article class="bundle tone-${b.tone}">
    <div class="bundle-win">
      <span class="bundle-save">Save ${b.pct}%</span>
      ${b.items.map(id => pic(P(id).img, "", P(id).shade ? 'style="height:52%;margin-bottom:10px"' : "")).join("")}
    </div>
    <div class="bundle-body">
      <h3>${b.name}</h3>
      <p class="muted">${b.line}</p>
      <ul>${b.items.map(id => `<li>${icon("i-check")}${P(id).name}</li>`).join("")}</ul>
      <div class="price">${priceHTML(b)}</div>
      <button class="btn btn-coral btn-block" data-add="${b.id}">Add set to bag</button>
    </div>
  </article>`;
}
function miniHTML(p, action=""){
  return `<a class="mini tone-${p.tone}" href="#/product/${p.id}">
    <span class="mini-win">${pic(p.img)}</span>
    <div>${p.short || p.name}<small>${p.spf} · ${money(p.price)}</small></div>${action}</a>`;
}
function faqHTML(f, open){
  return `<details class="faq" ${open ? "open" : ""}><summary>${f.q}${icon("i-plus")}</summary><p>${f.a}</p></details>`;
}
function fieldsHTML(v = {}){
  const g = k => esc(v[k] || "");
  return `
    <label class="field">Email<input id="f-email" name="email" type="email" required autocomplete="email" value="${g("email")}"></label>
    <label class="field">Mobile number<input id="f-phone" name="phone" type="tel" required pattern="[0-9]{10}" inputmode="numeric" autocomplete="tel-national" placeholder="10 digits" value="${g("phone")}"></label>
    <label class="field full">Full name<input id="f-name" name="name" required autocomplete="name" value="${g("name")}"></label>
    <label class="field full">Address<input id="f-addr" name="addr" required autocomplete="street-address" placeholder="House number, street, area" value="${g("addr")}"></label>
    <label class="field">City<input id="f-city" name="city" required autocomplete="address-level2" value="${g("city")}"></label>
    <label class="field">State<select id="f-state" name="state" required autocomplete="address-level1"><option value="">Choose your state</option>${STATES.map(s => `<option ${v.state===s?"selected":""}>${s}</option>`).join("")}</select></label>
    <label class="field">Pincode<input id="f-pin" name="pin" required pattern="[0-9]{6}" inputmode="numeric" autocomplete="postal-code" placeholder="6 digits" value="${g("pin")}"></label>`;
}

/* ---------- static renders ---------- */
const put = (sel, html) => { const el = $(sel); if (el) el.innerHTML = html; return el; };

/* fills in anything inside `root` that depends on product data: pictures, prices, savings, product grids */
function fillSections(root=document){
  $$("img[data-img]", root).forEach(im => { im.src = IMG[im.dataset.img] || ""; im.removeAttribute("data-img"); });
  $$("[data-price]", root).forEach(el => { const it = item(el.dataset.price); if (it) el.innerHTML = priceHTML(it); });
  $$("[data-pct]", root).forEach(el => { const b = B(el.dataset.pct); if (b) el.textContent = "Save " + b.pct + "%"; });
  const maxPct = Math.max(...BUNDLES.map(b => b.pct));
  $$("[data-bundle-note]", root).forEach(el => el.textContent = maxPct > 0 ? `Save up to ${maxPct}% on sets` : "Save when you buy a set");
  $$("[data-fl-products]", root).forEach(el => {
    const hs = el.dataset.flProducts.split(",").map(s => s.trim()).filter(Boolean);
    const list = hs.length ? hs.map(P).filter(Boolean) : PRODUCTS;
    el.innerHTML = list.map(cardHTML).join("");
  });
}

/* the home page sections. Each one is optional: the merchant can remove or reorder them in the theme editor. */
function renderHome(){
  // ribbon (when the section didn't already write it)
  const rib = $("#ribbon");
  if (rib && !rib.children.length) {
    const words = ["SPF 50 PA++++","No white cast","Ceramide barrier complex","5x hyaluronic acid","Kojic acid lip care","Made in small batches","Glow, protect, nourish"];
    const set = `<div class="ribbon-set">${words.map(w => `<span>${w}${icon("i-blossom")}</span>`).join("")}</div>`;
    rib.innerHTML = set + set + set + set;
  }

  // home range tabs
  put("#homeTabs", CATS.map(([k,l],i) => `<button class="tab" role="tab" aria-selected="${!i}" data-homecat="${k}">${l}</button>`).join(""));
  renderHomeGrid("all");

  // ingredients
  if (put("#ingList", INGREDIENTS.map((g,i) => `<button class="ing-btn" role="tab" aria-selected="${!i}" data-ing="${g.id}">${g.name}${icon("i-right")}</button>`).join(""))) renderIng(INGREDIENTS[0].id);

  // ritual
  syncRitual();
  put("#ritStage", RITUAL.map((s,i) => { const p = P(s.id); return `<div class="rit-shot tone-${p.tone} ${i?"":"is-on"}">
      ${pic(p.img, "", `class="cut" ${p.shade ? 'style="height:48%;margin-bottom:24%"' : ""}`)}
      ${photo(RITUAL_PHOTO[s.id] || p.life, "", 720, 900)}
      <div class="rit-chip"><span class="mini-win tone-${p.tone}">${pic(p.img)}</span><span>${p.short.replace(", Cherry Red","")}<small>${p.spf}</small></span></div></div>`; }).join(""));
  put("#ritSteps", RITUAL.map((s,i) => { const p = P(s.id); return `<li class="rit-step ${i?"":"is-on"}" data-rstep="${i}"><i></i>
      <h3><button type="button" aria-expanded="${!i}">${esc(s.title)}</button></h3>
      <div class="rit-more" ${i?"inert":""}><div><p>${esc(s.text)}</p><div class="rit-buy">${miniHTML(p)}<button class="btn btn-coral btn-sm" data-add="${p.id}">Add, ${money(p.price)}</button></div></div></div></li>`; }).join(""));
  const r = B("bundle-ritual");
  put("#ritualCta", `<div><strong>Get the whole routine for ${money(r.price)}</strong><span>${r.name}: all four products${r.pct ? `, ${r.pct}% less than buying them one by one (${money(r.mrp)})` : ""}.</span></div>
    <button class="btn btn-white" data-add="${r.id}">Add set to bag</button>`);

  // bundles
  put("#homeBundles", BUNDLES.map(bundleHTML).join(""));

  // closer look: the built-in pictures, then any pictures added in the theme editor
  const lookEl = $("#look");
  if (lookEl) {
    const extra = (readJSON("lookData") || []).filter(x => x && x.src).map((x, i) => { IMG["look:" + i] = x.src; return { img: "look:" + i, label: esc(x.label || "") }; });
    const looks = [...(lookEl.dataset.builtin === "false" ? [] : LOOKS), ...extra];
    lookEl.innerHTML = looks.map(l => {
      if (l.photo) { const p = P(l.pid); return `<a class="look-item is-photo tone-${p.tone}" href="#/product/${p.id}" draggable="false" aria-label="${PHOTOS[l.photo].alt}. Shop ${p.name}">
          ${photo(l.photo, "", 600, 800, "this.closest('.look-item').remove()")}
          <div class="look-tag"><div class="mini-win tone-${p.tone}">${pic(p.img)}</div><div>${p.short.replace(", Cherry Red","")}<small>${money(p.price)}</small></div>${icon("i-right")}</div></a>`; }
      return `<button class="look-item" data-light="${l.img}" aria-label="Open picture: ${l.label}">${pic(l.img, "", 'loading="lazy" draggable="false"')}${l.label ? `<span>${l.label}</span>` : ""}</button>`;
    }).join("");
    if (!lookEl.dataset.drag) { lookEl.dataset.drag = "1"; motion.drag(lookEl); }
    const prev = $("#lookPrev"), next = $("#lookNext");
    if (prev) prev.onclick = () => lookEl.scrollBy({ left: -lookEl.clientWidth * .8, behavior: "smooth" });
    if (next) next.onclick = () => lookEl.scrollBy({ left: lookEl.clientWidth * .8, behavior: "smooth" });
  }

  // faqs (only when the section left the list for the script to fill)
  put("#homeFaq", FAQS.filter(f => f.home).map((f,i) => faqHTML(f, !i)).join(""));
}

function renderStatic(){
  // announcement
  const an = $("#announce");
  an.innerHTML = CONFIG.announcements.map((t,i) => `<div class="announce-item ${i?"":"is-on"}"><span>${t}</span></div>`).join("");
  let ai = 0; const items = $$(".announce-item", an);
  if (items.length > 1 && !reduced) setInterval(() => {
    const cur = items[ai]; ai = (ai + 1) % items.length; const nxt = items[ai];
    cur.classList.add("is-out"); cur.classList.remove("is-on");
    nxt.classList.remove("is-out"); nxt.classList.add("is-on");
    setTimeout(() => cur.classList.remove("is-out"), 600);
  }, 4200);

  // mega menu + mobile nav + footer
  const maxPct = Math.max(...BUNDLES.map(b => b.pct));
  $("#mega").innerHTML = PRODUCTS.map(p => `<a class="mega-item tone-${p.tone}" href="#/product/${p.id}"><span class="mega-win">${pic(p.img, "", p.shade ? 'style="height:74%;margin-bottom:10px"' : "")}</span>${p.short}</a>`).join("")
    + `<div class="mega-side"><strong>Buy a set, save up to ${maxPct}%</strong><span class="muted">Three bundles built around the morning routine.</span><a class="link" href="#/shop/bundles">See bundles</a></div>`;
  $("#mnav").innerHTML = `<a href="#/">Home</a><a href="#/shop">Shop all</a><a href="#/routine">Find your routine</a>
    <small>Products</small>${PRODUCTS.map(p => `<a class="sub" href="#/product/${p.id}">${p.name}</a>`).join("")}
    <a class="sub" href="#/shop/bundles">Bundles</a>
    <small>Fléora</small><a class="sub" href="#/science">Ingredients</a><a class="sub" href="#/about">Our story</a><a class="sub" href="#/help">Help and contact</a><a class="sub" href="#/account">Account and saved items</a>`;
  $("#footShop").innerHTML = PRODUCTS.map(p => `<li><a href="#/product/${p.id}">${p.short}</a></li>`).join("") + `<li><a href="#/shop">Shop all</a></li>`;
  const ways = [
    CONFIG.whatsapp ? `<a href="${wa("Hi Fléora, I have a question.")}" target="_blank" rel="noopener">${icon("i-wa")}WhatsApp ${CONFIG.whatsappShown}</a>` : "",
    CONFIG.email ? `<a href="mailto:${CONFIG.email}">${icon("i-mail")}${CONFIG.email}</a>` : ""
  ].join("");
  $("#footContact").innerHTML = ways; $("#contactWays").innerHTML = ways;
  if (!CONFIG.formEndpoint && CONFIG.whatsapp) $("#contactBtn").innerHTML = icon("i-wa") + "Send on WhatsApp";
  $$("[data-social='instagram']").forEach(a => { if (CONFIG.instagram) a.href = CONFIG.instagram; else a.closest("[data-social-wrap]").hidden = true; });
  $("#notesBtn").hidden = !CONFIG.preview;

  // the home page sections, then pictures, prices and product grids everywhere
  renderHome();
  fillSections();

  // ingredients page
  $("#sciGrid").innerHTML = INGREDIENTS.map(g => `<article class="sci" id="sci-${g.id}"><span class="ing-role">${g.role}</span><h3>${g.name}</h3><p>${g.body}</p>
    <div class="pdp-chips">${g.products.map(id => `<a class="chip chip-line" href="#/product/${id}">${P(id).short}</a>`).join("")}</div></article>`).join("");

  // shop page bundles, help page faqs
  $("#shopBundles").innerHTML = BUNDLES.map(bundleHTML).join("");
  $("#helpFaq").innerHTML = FAQS.map((f,i) => faqHTML(f, !i)).join("");

  // shop tabs
  $("#shopTabs").innerHTML = [...CATS, ["bundles","Bundles"]].map(([k,l]) => `<a class="tab" role="tab" href="#/shop${k==="all"?"":"/"+k}" data-shopcat="${k}">${l}</a>`).join("");

  // policies nav, photos placed in markup, notes
  $("#policyNav").innerHTML = Object.keys(POLICIES).map(k => `<a href="#/policy/${k}" data-policy="${k}">${POLICIES[k].title}</a>`).join("");
  $$("img[data-photo]").forEach(im => { const k = im.dataset.photo; if (!PHOTOS[k]) return im.remove();
    im.className = "ph"; im.alt = PHOTOS[k].alt; im.loading = "lazy"; im.referrerPolicy = "no-referrer";
    im.onload = () => im.classList.add("is-ok"); im.onerror = () => im.remove(); im.src = photoSrc(k, 800, 1000); });
  $("#notesList").innerHTML = TEAM_NOTES.map(n => `<li>${n}</li>`).join("");

  // structured data for search engines
  const ld = document.createElement("script"); ld.type = "application/ld+json";
  ld.textContent = JSON.stringify({ "@context":"https://schema.org", "@graph":[
    { "@type":"Organization", name: CONFIG.brand, legalName: CONFIG.company, email: CONFIG.email },
    ...PRODUCTS.map(p => ({ "@type":"Product", name: plain(p.name), description: plain(p.desc), brand: { "@type":"Brand", name: CONFIG.brand },
      offers: { "@type":"Offer", priceCurrency:"INR", price: p.price, availability: p.available === false ? "https://schema.org/OutOfStock" : "https://schema.org/InStock" } }))
  ]});
  document.head.append(ld);
}
function renderHomeGrid(cat){
  put("#homeGrid", PRODUCTS.filter(p => cat === "all" || p.cat === cat).map(cardHTML).join(""));
  $$("[data-homecat]").forEach(t => t.setAttribute("aria-selected", t.dataset.homecat === cat));
}
function renderIng(id){
  const g = INGREDIENTS.find(x => x.id === id);
  $$("[data-ing]").forEach(b => b.setAttribute("aria-selected", b.dataset.ing === id));
  if (!$("#ingPanel")) return;
  $("#ingPanel").innerHTML = `<p class="ing-role">${g.role}</p><h3>${g.name}</h3><p>${g.body}</p>
    <div class="ing-in"><span>Find it in</span><div class="minis">${g.products.map(pid => miniHTML(P(pid))).join("")}</div></div>`;
}
function renderShop(cat="all"){
  if (![...CATS.map(c=>c[0]),"bundles"].includes(cat)) cat = "all";
  const sort = $("#shopSort").value;
  let list = PRODUCTS.filter(p => cat === "all" || p.cat === cat);
  if (sort === "low") list = [...list].sort((a,b) => a.price - b.price);
  if (sort === "high") list = [...list].sort((a,b) => b.price - a.price);
  $("#shopGrid").innerHTML = cat === "bundles" ? "" : list.map(cardHTML).join("");
  $("#shopGrid").hidden = cat === "bundles";
  $("#shopBundlesWrap").hidden = !(cat === "all" || cat === "bundles");
  $("#shopBundlesWrap").style.marginTop = cat === "bundles" ? "0" : "72px";
  $$("[data-shopcat]").forEach(t => { const on = t.dataset.shopcat === cat; t.classList.toggle("is-on", on); t.setAttribute("aria-selected", on); });
  $("#shopSort").closest("label").style.visibility = cat === "bundles" ? "hidden" : "visible";
}

/* ---------- ritual (home) ---------- */
const ritual = (() => {
  let cur = 0;
  function go(i, byUser){
    const steps = $$(".rit-step"), shots = $$(".rit-shot");
    if (!steps.length) return;
    cur = (i + steps.length) % steps.length;
    steps.forEach((s,k) => { const on = k === cur; s.classList.toggle("is-on", on);
      $("button", s).setAttribute("aria-expanded", on); $(".rit-more", s).inert = !on; });
    shots.forEach((s,k) => s.classList.toggle("is-on", k === cur));
    if (byUser) $("#rit").classList.remove("is-auto");
  }
  function init(){
    const root = $("#rit"); if (!root) return;
    $$(".rit-step > i", root).forEach(i => i.addEventListener("animationend", () => go(cur + 1)));
    if (!reduced && "IntersectionObserver" in window) {
      let touched = false;
      root.addEventListener("pointerdown", () => { touched = true; root.classList.remove("is-auto"); });
      root.addEventListener("focusin", () => { touched = true; root.classList.remove("is-auto"); });
      new IntersectionObserver(es => es.forEach(e => { if (!touched) root.classList.toggle("is-auto", e.isIntersecting); }), { threshold:.35 }).observe(root);
    }
  }
  return { go, init };
})();

/* ---------- product page ---------- */
let pdpQty = 1, pdpId = null;
function renderProduct(id){
  const p = P(id); if (!p) { location.hash = "#/shop"; return; }
  id = p.id; pdpId = id; pdpQty = 1;
  document.title = `${plain(p.name)} — Fléora`;
  $("#crumbName").textContent = plain(p.name);
  const shots = [{k:p.img, cut:true}, ...p.gallery.map(k => ({k}))];
  const bundle = BUNDLES.find(b => b.items.includes(id) && b.items.length === 2 && b.pct > 0);
  const heroIng = INGREDIENTS.filter(g => g.products.includes(id));
  const lifeThumb = p.life ? `<button class="pdp-thumb is-life" hidden data-life="${p.life}" aria-pressed="false" aria-label="Picture: on skin"><img src="${photoSrc(p.life, 160, 200)}" alt="" referrerpolicy="no-referrer" onload="this.parentNode.hidden=false" onerror="this.parentNode.remove()"></button>` : "";
  const [made, marketed] = p.maker.replace(/\.$/, "").split(". ");
  $("#pdp").innerHTML = `
    <div class="pdp-gallery tone-${p.tone}">
      <div class="pdp-thumbs">${shots.map((s,i) => `<button class="pdp-thumb ${s.cut?"is-cut":""}" aria-pressed="${!i}" data-shot="${s.k}" data-cut="${s.cut?1:""}" aria-label="Picture ${i+1}">${pic(s.k)}</button>`).join("")}${lifeThumb}</div>
      <div class="pdp-stage" id="pdpStage">${pic(p.img, p.name, `class="cut" ${p.shade ? 'style="height:60%;margin-bottom:60px"' : ""}`)}</div>
      <div class="pdp-swipe" id="pdpSwipe">
        <div class="sw-item is-cut">${pic(p.img, p.name, p.shade ? 'style="height:58%;margin-bottom:54px"' : "")}</div>
        ${p.gallery.map(k => `<div class="sw-item">${pic(k, p.name, `data-light="${k}" loading="lazy"`)}</div>`).join("")}
        ${p.life ? `<div class="sw-item is-life">${photo(p.life, "", 700, 820, "this.parentNode.remove();initSwipe()")}</div>` : ""}
      </div>
      <div class="sw-dots" id="swDots" aria-hidden="true"></div>
    </div>
    <div class="pdp-info">
      <div class="pcard-meta"><span class="chip">${p.spf}</span>${p.size ? `<span>${p.size}</span>` : ""}<span>All skin types</span></div>
      <div class="pdp-title"><h1>${p.name}</h1><button class="iconbtn pdp-wish" data-wish="${id}" aria-pressed="${wish.has(id)}" aria-label="Save ${p.name} for later">${icon("i-heart")}</button></div>
      <p class="lead">${p.tagline}</p>
      <div class="pdp-price">${priceHTML(p)}</div>
      <p class="pdp-tax">MRP inclusive of all taxes</p>
      ${p.shade ? `<div class="shades">Shade ${[p, P(p.sibling)].sort((a,b)=>a.id<b.id?-1:1).map(s => `<a class="shade ${s.id===id?"is-on":""}" style="--c:${s.shade.color}" href="#/product/${s.id}" aria-label="${s.shade.name}" ${s.id===id?'aria-current="true"':""}></a>`).join("")}<span class="muted">${p.shade.name}</span></div>` : ""}
      <p>${p.desc}</p>
      <div class="pdp-chips">${p.badges.map(b => `<span class="chip chip-line">${b}</span>`).join("")}</div>
      <ul class="offer">
        <li>${icon("i-check")}<span>Use code <b>${CONFIG.coupon.code}</b> for ${CONFIG.coupon.pct}% off your first order</span></li>
        ${CONFIG.prepaidPct ? `<li>${icon("i-check")}<span>Extra ${CONFIG.prepaidPct}% off when you pay online</span></li>` : ""}
        ${bundle ? `<li>${icon("i-check")}<span>Save ${bundle.pct}% with ${bundle.name} <button class="link" data-add="${bundle.id}" style="margin-left:6px">Add set, ${money(bundle.price)}</button></span></li>` : ""}
      </ul>
      <div class="buy">
        <div class="qty" aria-label="Quantity"><button data-qty="-1" aria-label="Decrease quantity">${icon("i-minus")}</button><span id="pdpQty" aria-live="polite">1</span><button data-qty="1" aria-label="Increase quantity">${icon("i-plus")}</button></div>
        <button class="btn btn-coral" data-add="${id}" data-useqty>${p.available === false ? "Sold out" : "Add to bag"}</button>
        <button class="btn btn-line" data-buy="${id}">Buy now</button>
      </div>
      <ul class="pdp-ship">
        <li>${icon("i-truck")}Free shipping above ${money(CONFIG.freeShipAt)}. Dispatched ${CONFIG.dispatch}.</li>
        <li>${icon("i-box")}Cash on delivery available. Unopened returns within 7 days.</li>
      </ul>
      <ul class="benefits">${p.benefits.map(b => `<li>${icon("i-check")}<span>${b}</span></li>`).join("")}</ul>
      <div class="acc">
        ${p.howToUse.length ? `<details class="faq" open><summary>How to use${icon("i-plus")}</summary><div class="faq-body"><ol class="steps">${p.howToUse.map(s => `<li>${s}</li>`).join("")}</ol></div></details>` : ""}
        <details class="faq"><summary>Hero ingredients${icon("i-plus")}</summary><div class="faq-body">${heroIng.map(g => `<p style="padding:0 0 10px"><b style="color:var(--plum)">${g.name}.</b> ${g.role}.</p>`).join("")}<a class="link" href="#/science">Read our science</a></div></details>
        ${p.ingredients ? `<details class="faq"><summary>Full ingredient list${icon("i-plus")}</summary><p class="inci">${p.ingredients}</p></details>` : ""}
        <details class="faq"><summary>Shipping and returns${icon("i-plus")}</summary><p>Orders ship pan-India, free above ${money(CONFIG.freeShipAt)}, and usually arrive in ${CONFIG.delivery}. Unopened products may be returned within 7 days of delivery. <a class="link" href="#/policy/returns">Read the full policy</a></p></details>
        <details class="faq"><summary>Product information${icon("i-plus")}</summary><div class="faq-body"><dl class="facts">
          <dt>Net quantity</dt><dd>${p.size || "See pack"}</dd>
          <dt>MRP</dt><dd>${money(p.mrp)} (inclusive of all taxes)</dd>
          <dt>Manufacturer</dt><dd>${(made || "").replace("Manufactured by ", "")}</dd>
          <dt>Marketer</dt><dd>${(marketed || "").replace("Marketed by ", "")}</dd>
          <dt>Country of origin</dt><dd>India</dd>
          <dt>Best before</dt><dd>See the date printed on the pack</dd>
          <dt>Customer care</dt><dd>${CONFIG.email}${CONFIG.whatsappShown ? ", " + CONFIG.whatsappShown : ""}</dd>
        </dl></div></details>
      </div>
    </div>`;
  $("#pdpRelated").innerHTML = PRODUCTS.filter(x => x.id !== id).map(cardHTML).join("");
  $("#stickyBuy").innerHTML = `<div><div style="font-weight:650;font-size:.9rem;line-height:1.2">${p.short}</div><div class="price">${priceHTML(p)}</div></div><button class="btn btn-coral btn-sm" data-add="${id}" data-useqty>Add to bag</button>`;
  initSwipe();
}
function initSwipe(){
  const sw = $("#pdpSwipe"), dots = $("#swDots"); if (!sw) return;
  const n = sw.children.length;
  dots.innerHTML = n > 1 ? Array.from({length:n}, (_,i) => `<i class="${i?"":"is-on"}"></i>`).join("") : "";
  sw.onscroll = () => { const i = Math.round(sw.scrollLeft / (sw.firstElementChild.offsetWidth + 10)); $$("i", dots).forEach((d,k) => d.classList.toggle("is-on", k === i)); };
}

/* ---------- find your routine ---------- */
const RT_Q = [
  { q: "How much sun does your day get?", opts: [
    { v:"in",   t:"Mostly indoors",  d:"Home, office, a short commute." },
    { v:"mix",  t:"In and out",      d:"Errands, lunch outside, the school run." },
    { v:"out",  t:"Mostly outdoors", d:"Long commutes, sport, travel, fieldwork." } ] },
  { q: "Do you already have a daily moisturiser you love?", opts: [
    { v:"no",   t:"Not really",          d:"I'd like one that does the job in a single step." },
    { v:"yes",  t:"Yes, I'm keeping it", d:"I only want sun protection on top." } ] },
  { q: "And for your lips?", opts: [
    { v:"cherry", t:"Juicy cherry",   d:"A sheer red wash with SPF 50.", dots:["var(--cherry)"] },
    { v:"mauve",  t:"Soft mauve",     d:"Your lips but better, with SPF 50.", dots:["var(--mauve)"] },
    { v:"both",   t:"Both shades",    d:"One for each mood, and you save 10%.", dots:["var(--cherry)","var(--mauve)"] },
    { v:"none",   t:"No lip balm",    d:"Just face and body for now." } ] }
];
let rt = { step: 0, a: [] };
function routineResult([sun, hasMoist, lips]){
  const lotion = hasMoist === "no", mist = sun !== "in" || hasMoist === "yes";
  const why = [];
  if (lotion) why.push(["Ceramide Hydrating Lotion", "moisture and SPF 30 in one step, so it replaces your moisturiser."]);
  if (mist) why.push(["Rice Water Sunscreen Mist", lotion ? "SPF 50 on top, and easy to reapply over makeup when you're out." : "SPF 50 over the moisturiser you already use, with no white cast."]);
  if (lotion && !mist) why.push(["On indoor days", "the lotion's SPF 30 is enough on its own. Add the mist when you plan to be out longer."]);
  if (lips === "cherry" || lips === "both") why.push(["Tinted Kojic Lip Balm, Cherry Red", "a sheer red wash with SPF 50."]);
  if (lips === "mauve" || lips === "both") why.push(["Tinted Kojic Lip Balm, Mauve", "a soft everyday tint with SPF 50."]);
  let ids = [];
  if (lotion && mist && lips === "both") ids = ["bundle-ritual"];
  else {
    if (lotion && mist) ids.push("bundle-duo"); else { if (lotion) ids.push("hydration-lotion"); if (mist) ids.push("sunscreen-mist"); }
    if (lips === "both") ids.push("bundle-lips"); else if (lips !== "none") ids.push("lip-balm-" + lips);
  }
  const prods = ids.flatMap(id => (B(id) ? B(id).items : [id]));
  const full = prods.reduce((s, id) => s + P(id).price, 0), price = ids.reduce((s, id) => s + item(id).price, 0);
  return { ids, prods, why, full, price };
}
function renderRoutine(){
  const el = $("#rt"), n = RT_Q.length;
  const dots = `<div class="rt-dots" aria-hidden="true">${RT_Q.map((_,i) => `<i class="${i <= Math.min(rt.step, n-1) ? "is-on" : ""}"></i>`).join("")}</div>`;
  if (rt.step < n) {
    const q = RT_Q[rt.step];
    el.innerHTML = `${dots}<div class="rt-step">
      <p class="rt-count">Question ${rt.step + 1} of ${n}</p>
      <h1 class="rt-q">${q.q}</h1>
      <div class="rt-opts">${q.opts.map(o => `<button class="rt-opt" data-rt="${o.v}"><strong>${(o.dots||[]).map(c => `<i class="dot" style="--c:${c}"></i>`).join("")}${o.t}</strong><span>${o.d}</span></button>`).join("")}</div>
      ${rt.step ? `<button class="rt-back" data-rt-back>${icon("i-left")}Back</button>` : `<p class="muted small">Three questions. Takes about twenty seconds.</p>`}
    </div>`;
    return;
  }
  const r = routineResult(rt.a), save = r.full - r.price;
  const names = r.ids.map(id => item(id).name);
  el.innerHTML = `${dots}<div class="rt-step">
    <h1 class="rt-q">Your routine is ready.</h1>
    <div class="rt-res">
      <div class="rt-pics">${r.prods.map(id => pic(P(id).img, P(id).name, P(id).shade ? 'class="is-lip"' : "")).join("")}</div>
      <div class="rt-body">
        <h2>${names.join(" + ")}</h2>
        <ul class="rt-why">${r.why.map(([a,b]) => `<li>${icon("i-check")}<span><b>${a}:</b> ${b}</span></li>`).join("")}</ul>
        <div class="rt-total"><b>${money(r.price)}</b>${save > 0 ? `<s>${money(r.full)}</s><em>You save ${money(save)}</em>` : ""}</div>
        <button class="btn btn-coral btn-block" data-rt-add="${r.ids.join(",")}">Add my routine to bag</button>
        <button class="rt-back" data-rt-reset style="align-self:center">${icon("i-left")}Start again</button>
      </div>
    </div></div>`;
}

/* ---------- policies + account ---------- */
let shopBox = null;
function renderPolicy(id){
  if (!POLICIES[id]) id = "shipping";
  const p = POLICIES[id];
  $("#policyTitle").textContent = p.title; $("#policyLead").textContent = p.lead;
  $("#policyBody").innerHTML = p.body();
  if (id === "shopify" && shopBox) { $("#shopifyMount").append(shopBox); shopBox.hidden = false; }
  $$("[data-policy]").forEach(a => a.classList.toggle("is-on", a.dataset.policy === id));
  document.title = `${p.title} — Fléora`;
}
function renderAccount(){
  const me = store.get("fleora_me", {});
  $("#meForm").innerHTML = fieldsHTML(me).replace(/ required/g, "") + `<button class="btn btn-coral full" type="submit" style="justify-self:start">Save details</button>`;
  const w = [...wish].map(P).filter(Boolean);
  $("#wishList").innerHTML = w.length ? `<div class="wl">${w.map(p => `<div class="mini tone-${p.tone}"><a class="mini-win" href="#/product/${p.id}" aria-label="${p.name}">${pic(p.img)}</a><div><a href="#/product/${p.id}">${p.short}</a><small>${money(p.price)}</small></div><button class="btn btn-line btn-sm" data-add="${p.id}">Add</button><button class="iconbtn wish-on" data-wish="${p.id}" aria-label="Remove ${p.name} from saved">${icon("i-heart")}</button></div>`).join("")}</div>`
    : `<p class="empty-sm">Nothing saved yet. Tap the heart on any product to keep it here.</p>`;
  const orders = store.get("fleora_orders", []);
  $("#orderList").innerHTML = orders.length ? `<div class="olist">${orders.map(o => `<div class="ocard">
      <div class="row"><b>${o.ref}</b><b>${money(o.total)}</b></div>
      <small>${new Date(o.at).toLocaleDateString("en-IN", { day:"numeric", month:"short", year:"numeric" })} · ${o.payLabel}</small>
      <span>${o.items.map(i => `${i.qty} × ${esc(i.name)}`).join(", ")}</span>
      ${o.wa ? `<a class="link" style="justify-self:start;margin-top:6px" href="${o.wa}" target="_blank" rel="noopener">Send or resend on WhatsApp</a>` : ""}</div>`).join("")}</div>`
    : `<p class="empty-sm">No orders from this device yet.</p>`;
  if (SHOP) $("#orderList").innerHTML = `<p class="empty-sm">Your orders, tracking and saved addresses are kept in your store account.</p><a class="btn btn-line" href="${esc(SHOP.accountUrl || shopRoot + "account")}" style="margin-top:12px">View your orders</a>`;
}
function syncWish(){
  const c = $("#wishCount"); c.textContent = wish.size; c.hidden = !wish.size;
  $$("[data-wish]").forEach(b => b.setAttribute("aria-pressed", wish.has(b.dataset.wish)));
}

/* ---------- bag ---------- */
function totals(prepaid=false){
  const sub = Object.keys(cart).reduce((s,id) => s + item(id).price * cart[id], 0);
  const disc = couponOn ? Math.round(sub * CONFIG.coupon.pct / 100) : 0;
  const after = sub - disc;
  const ship = (!sub || after >= CONFIG.freeShipAt) ? 0 : CONFIG.shipFee;
  const pre = prepaid ? Math.round(after * CONFIG.prepaidPct / 100) : 0;
  return { sub, disc, ship, pre, after, total: after + ship - pre, count: Object.values(cart).reduce((a,b) => a+b, 0) };
}
function add(id, qty=1){
  const it = item(id); if (!it) return false;
  id = it.id;
  if (SHOP && it.available === false) { toast(`${it.name} is sold out right now`); return false; }
  cart[id] = (cart[id] || 0) + qty; saveCart(); renderCart(); return true;
}
function setQty(id, d){ cart[id] = (cart[id] || 0) + d; if (cart[id] <= 0) delete cart[id]; saveCart(); renderCart(); }
/* if every product of a set is in the bag on its own, offer the set price */
function bundleNudge(){
  const b = [...BUNDLES].sort((x,y) => y.items.length - x.items.length).find(b => b.items.every(id => cart[id] > 0));
  if (!b) return "";
  return `<div class="nudge"><span>These make <b>${b.name}</b>. Switch to the set and save <b>${money(b.mrp - b.price)}</b>.</span><button class="btn btn-coral btn-sm" data-swap="${b.id}">Switch</button></div>`;
}
function lineHTML(id, editable=true){
  const it = item(id), isB = !!it.items, img = isB ? P(it.items[0]) : it;
  return `<div class="line tone-${it.tone}">
    <span class="mini-win">${pic(img.img)}</span>
    <div><h3>${it.name}</h3>
      <p class="small">${isB ? it.items.length + " products" + (it.pct ? ", " + it.pct + "% off" : "") : [it.spf, it.size].filter(Boolean).join(" · ")}</p>
      <div class="line-row">
        ${editable ? `<div class="qty qty-sm"><button data-cartqty="${id}" data-d="-1" aria-label="Decrease quantity">${icon("i-minus")}</button><span>${cart[id]}</span><button data-cartqty="${id}" data-d="1" aria-label="Increase quantity">${icon("i-plus")}</button></div>` : `<span class="small">Qty ${cart[id]}</span>`}
        <b>${money(it.price * cart[id])}</b>
      </div>
      ${editable ? `<button class="line-remove" data-remove="${id}" style="margin-top:8px">Remove</button>` : ""}
    </div></div>`;
}
function renderCart(){
  const t = totals(), ids = Object.keys(cart);
  const bc = $("#bagCount"); bc.textContent = t.count; bc.hidden = !t.count;
  const left = CONFIG.freeShipAt - t.after;
  $("#shipBar").innerHTML = !t.count ? `Free shipping on orders above ${money(CONFIG.freeShipAt)}`
    : (left > 0 ? `You're ${money(left)} away from free shipping` : `You've unlocked free shipping`) +
      `<div class="track"><i style="width:${Math.min(100, t.after / CONFIG.freeShipAt * 100)}%"></i></div>`;
  if (!ids.length){
    $("#cartBody").innerHTML = `<div class="empty">${icon("i-blossom")}<p>Your bag is empty.</p><a class="btn btn-coral" href="#/shop" data-close>Shop the range</a><a class="link" href="#/routine" data-close>Or find your routine</a></div>`;
    $("#cartFoot").hidden = true;
  } else {
    const inCart = new Set(ids.flatMap(id => item(id).items || [id]));
    const sug = PRODUCTS.filter(p => !inCart.has(p.id)).slice(0, 2);
    $("#cartBody").innerHTML = ids.map(id => lineHTML(id)).join("") + bundleNudge() +
      (sug.length ? `<div class="upsell"><span>Complete your routine</span><div style="display:grid;gap:10px">${sug.map(p =>
        `<div class="mini tone-${p.tone}"><span class="mini-win">${pic(p.img)}</span><div>${p.short}<small>${money(p.price)}</small></div><button class="btn btn-line btn-sm" data-add="${p.id}">Add</button></div>`).join("")}</div></div>` : "");
    $("#cartFoot").hidden = false;
    $("#cartFoot").innerHTML = `
      ${couponOn ? `<p class="small" style="margin-bottom:12px;display:flex;justify-content:space-between;gap:10px"><span>Code <b>${CONFIG.coupon.code}</b> applied</span><button class="line-remove" data-coupon-off>Remove</button></p>`
        : `<form class="coupon" data-form="coupon"><label class="sr" for="couponIn">Discount code</label><input id="couponIn" placeholder="Discount code" autocomplete="off"><button class="btn btn-line btn-sm" type="submit">Apply</button></form>`}
      <div class="sum-rows" style="border:0;margin:0;padding:0 0 14px">
        <div><span>Subtotal</span><span>${money(t.sub)}</span></div>
        ${t.disc ? `<div class="neg"><span>${CONFIG.coupon.code}</span><span>−${money(t.disc)}</span></div>` : ""}
        <div><span>Shipping</span><span>${t.ship ? money(t.ship) : "Free"}</span></div>
        <div class="total"><span>Total</span><span>${money(t.total)}</span></div>
      </div>
      <a class="btn btn-coral btn-block" href="#/checkout" data-close>Go to checkout</a>`;
  }
  if (current === "checkout" && !orderDone) renderCheckout();
}
function openCart(){ $$("dialog[open]").forEach(x => x.close()); $("#cartDlg").showModal(); }

/* product picture flies to the bag, then the bag opens */
function fly(src){
  const bag = $("#bagBtn");
  if (reduced || !src || !src.getBoundingClientRect || !bag.animate) return Promise.resolve();
  const r = src.getBoundingClientRect(); if (!r.width || r.bottom < 0 || r.top > innerHeight) return Promise.resolve();
  $("#head").classList.remove("is-hidden");
  const b = bag.getBoundingClientRect();
  const c = new Image(); c.src = src.currentSrc || src.src; c.className = "fly"; c.alt = "";
  c.style.width = r.width + "px"; c.style.height = r.height + "px";
  document.body.append(c);
  const dx = b.left + b.width/2 - (r.left + r.width/2), dy = b.top + b.height/2 - (r.top + r.height/2);
  return c.animate([
    { transform:`translate(${r.left}px,${r.top}px) scale(1)`, opacity:1 },
    { transform:`translate(${r.left + dx*.55}px,${r.top + dy*.55 - 70}px) scale(.55)`, opacity:1, offset:.55 },
    { transform:`translate(${r.left + dx}px,${r.top + dy}px) scale(.06)`, opacity:.3 }
  ], { duration: 640, easing:"cubic-bezier(.5,0,.3,1)" }).finished.catch(() => {}).then(() => {
    c.remove(); bag.classList.remove("bump"); void bag.offsetWidth; bag.classList.add("bump");
  });
}
function flySource(btn){
  const box = btn.closest(".pcard,.slide,.bundle,.rit-step,.qv,.rt-res,.wl .mini,.page-product,#ritual");
  if (!box) return null;
  return $$(".pcard-win img:not(.pcard-alt),.stage-prod,.win img,.bundle-win img,.mini-win img,.qv-win img,.rt-pics img,.pdp-stage img,.sw-item.is-cut img,.rit-shot.is-on .cut", box)
    .find(im => im.offsetParent !== null && im.getBoundingClientRect().width > 0) || null;
}

/* ---------- Shopify checkout ----------
   The bag is copied into the store's cart, then the visitor is sent to Shopify's own checkout.
   When they come back after paying, the store cart is empty and the bag here is emptied too. */
let coBusy = false;
const shopJSON = { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" } };
function shopifyCheckout(){
  const ids = Object.keys(cart);
  if (!ids.length) { toast("Your bag is empty"); return; }
  const miss = ids.find(id => !item(id).variantId);
  if (miss) { toast(`${item(miss).name} isn't in the Shopify store yet, so checkout can't open`); return; }
  if (coBusy) return; coBusy = true;
  toast("Taking you to secure checkout…");
  const items = ids.map(id => ({ id: item(id).variantId, quantity: cart[id] }));
  const dest = couponOn ? `${shopRoot}discount/${encodeURIComponent(CONFIG.coupon.code)}?redirect=${encodeURIComponent(shopRoot + "checkout")}` : shopRoot + "checkout";
  fetch(shopRoot + "cart/clear.js", shopJSON)
    .then(() => fetch(shopRoot + "cart/add.js", { ...shopJSON, body: JSON.stringify({ items }) }))
    .then(r => r.ok ? r : r.json().catch(() => ({})).then(j => { throw { shown: j.description || j.message || "One of these products can't be added right now" }; }))
    .then(() => { store.set("fleora_co", Date.now()); location.href = dest; })
    .catch(err => { coBusy = false; toast(err && err.shown ? esc(err.shown) : "Checkout couldn't open. Check your connection and try again."); });
}
function shopifyOrderCheck(){
  const at = store.get("fleora_co", 0); if (!SHOP || !at) return;
  if (Date.now() - at > 3 * 864e5) { store.set("fleora_co", 0); return; }
  fetch(shopRoot + "cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } }).then(r => r.json()).then(c => {
    if (c && c.item_count === 0) { cart = {}; couponOn = false; saveCart(); store.set("fleora_co", 0); renderCart(); }
  }).catch(() => {});
}
addEventListener("pageshow", e => { coBusy = false; if (e.persisted) shopifyOrderCheck(); });

/* ---------- checkout ---------- */
let orderDone = false;
const onlineOK = () => !!(CONFIG.razorpayKey || CONFIG.whatsapp);
function renderCheckout(){
  const el = $("#checkout"); orderDone = false;
  const ids = Object.keys(cart);
  if (!ids.length){
    el.innerHTML = `<div class="done"><div class="ring">${icon("i-bag")}</div><h1 class="h-section">Your bag is empty.</h1><p class="muted">Add a product to start checkout.</p><a class="btn btn-coral" href="#/shop">Shop the range</a></div>`;
    return;
  }
  const prev = $("#coForm") ? Object.fromEntries(new FormData($("#coForm"))) : { ...store.get("fleora_me", {}), remember: "on" };
  const pay = prev.pay || (onlineOK() ? "online" : "cod"), t = totals(pay === "online");
  const viaRzp = pay === "online" && CONFIG.razorpayKey;
  const cta = viaRzp ? `Pay ${money(t.total)}` : CONFIG.whatsapp && !CONFIG.orderEndpoint ? `Place order on WhatsApp, ${money(t.total)}` : `Place order, ${money(t.total)}`;
  const hint = viaRzp ? "You'll pay securely with Razorpay: UPI, cards or net banking."
    : CONFIG.whatsapp ? (pay === "online" ? "WhatsApp opens with your order written out. Send it, and we reply with a secure payment link." : "WhatsApp opens with your order written out. Send it, and we confirm your delivery.")
    : CONFIG.orderEndpoint ? "We'll confirm your order by message." : "Preview only. Ordering isn't connected yet.";
  el.innerHTML = `
  <div class="crumbs"><a href="#/shop">Shop</a> / Checkout</div>
  <form class="co" id="coForm" data-form="checkout">
    <div>
      <h2>Contact and delivery</h2>
      <div class="form form-2">${fieldsHTML(prev)}</div>
      <label class="co-save"><input type="checkbox" name="remember" ${prev.remember ? "checked" : ""}>Save these details on this device for next time</label>
      <h2>Payment</h2>
      <div class="pay">
        ${onlineOK() ? `<label><input type="radio" name="pay" value="online" ${pay==="online"?"checked":""}><span>UPI, card or net banking<small>${CONFIG.razorpayKey ? "Pay securely now" : "We send you a secure payment link"} · ${CONFIG.prepaidPct}% off</small></span></label>` : ""}
        <label><input type="radio" name="pay" value="cod" ${pay==="cod"?"checked":""}><span>Cash on delivery<small>Pay when your order arrives</small></span></label>
      </div>
    </div>
    <aside class="summary">
      <h2 style="margin:0 0 4px">Order summary</h2>
      ${ids.map(id => lineHTML(id, false)).join("")}
      <div class="sum-rows">
        <div><span>Subtotal</span><span>${money(t.sub)}</span></div>
        ${t.disc ? `<div class="neg"><span>Code ${CONFIG.coupon.code}</span><span>−${money(t.disc)}</span></div>` : ""}
        ${t.pre ? `<div class="neg"><span>Online payment offer</span><span>−${money(t.pre)}</span></div>` : ""}
        <div><span>Shipping</span><span>${t.ship ? money(t.ship) : "Free"}</span></div>
        <div class="total"><span>Total</span><span>${money(t.total)}</span></div>
      </div>
      <button class="btn ${viaRzp || !CONFIG.whatsapp || CONFIG.orderEndpoint ? "btn-coral" : "btn-wa"} btn-block" type="submit" id="coBtn" style="margin-top:18px">${!viaRzp && CONFIG.whatsapp && !CONFIG.orderEndpoint ? icon("i-wa") : ""}${cta}</button>
      <p class="co-hint">${icon("i-shield")}<span>${hint}</span></p>
    </aside>
  </form>`;
}
function orderText(o){
  const c = o.customer;
  return [
    `New ${CONFIG.brand} order ${o.ref}`, "",
    ...o.items.map(i => `${i.qty} × ${i.name}${i.size ? " (" + i.size + ")" : ""} — ${money(i.price * i.qty)}`), "",
    `Subtotal: ${money(o.t.sub)}`,
    o.t.disc ? `Code ${o.coupon}: −${money(o.t.disc)}` : null,
    o.t.pre ? `Online payment offer: −${money(o.t.pre)}` : null,
    `Shipping: ${o.t.ship ? money(o.t.ship) : "Free"}`,
    `Total: ${money(o.total)}`, "",
    `Payment: ${o.payLabel}`, "",
    "Deliver to:", c.name, c.addr, `${c.city}, ${c.state} ${c.pin}`, `Phone: ${c.phone}`, `Email: ${c.email}`
  ].filter(x => x !== null).join("\n");
}
function placeOrder(f){
  const d = Object.fromEntries(new FormData(f)), pay = d.pay || "cod", t = totals(pay === "online");
  const customer = { name:d.name, email:d.email, phone:d.phone, addr:d.addr, city:d.city, state:d.state, pin:d.pin };
  if (d.remember) store.set("fleora_me", customer);
  const now = new Date(), pad = n => String(n).padStart(2, "0");
  const o = {
    ref: `FL-${String(now.getFullYear()).slice(2)}${pad(now.getMonth()+1)}${pad(now.getDate())}-${Math.floor(1000 + Math.random() * 9000)}`,
    at: now.getTime(), customer, t, total: t.total, coupon: couponOn ? CONFIG.coupon.code : "", pay,
    payLabel: pay === "cod" ? "Cash on delivery" : CONFIG.razorpayKey ? "Paid online" : "UPI or card (payment link requested)",
    items: Object.keys(cart).map(id => ({ id, name: item(id).name, size: item(id).size || (item(id).items ? item(id).items.map(x => P(x).short).join(" + ") : ""), qty: cart[id], price: item(id).price }))
  };
  if (pay === "online" && CONFIG.razorpayKey) return payRazorpay(o);
  finishOrder(o, true);
}
function payRazorpay(o){
  const btn = $("#coBtn"); btn.disabled = true;
  const fail = msg => { btn.disabled = false; toast(msg); };
  const load = window.Razorpay ? Promise.resolve() : new Promise((ok, no) => { const s = document.createElement("script"); s.src = "https://checkout.razorpay.com/v1/checkout.js"; s.onload = ok; s.onerror = no; document.head.append(s); });
  load.then(() => {
    const rz = new window.Razorpay({
      key: CONFIG.razorpayKey, amount: o.total * 100, currency: "INR", name: CONFIG.brand, description: `Order ${o.ref}`,
      prefill: { name: o.customer.name, email: o.customer.email, contact: o.customer.phone },
      notes: { order_ref: o.ref, items: o.items.map(i => `${i.qty}x ${i.name}`).join(", ").slice(0, 250), address: `${o.customer.addr}, ${o.customer.city}, ${o.customer.state} ${o.customer.pin}`.slice(0, 250) },
      theme: { color: "#5C4358" },
      handler: res => { o.paymentId = res.razorpay_payment_id; finishOrder(o, false); },
      modal: { ondismiss: () => fail("Payment cancelled. Your bag is still here.") }
    });
    rz.on("payment.failed", () => fail("That payment didn't go through. Try again or choose cash on delivery."));
    rz.open();
  }).catch(() => fail("The payment window couldn't load. Check your connection and try again."));
}
function finishOrder(o, userClick){
  o.wa = wa(orderText(o) + (o.paymentId ? `\nPayment ID: ${o.paymentId}` : ""));
  post(CONFIG.orderEndpoint, o);
  const saved = store.get("fleora_orders", []);
  saved.unshift({ ref:o.ref, at:o.at, total:o.total, payLabel:o.payLabel, items:o.items.map(i => ({ name:i.name, qty:i.qty })), wa:o.wa });
  store.set("fleora_orders", saved.slice(0, 20));
  const paid = !!o.paymentId, logged = !!CONFIG.orderEndpoint, needsWa = !paid && !logged && !!o.wa, nothing = !paid && !logged && !o.wa;
  cart = {}; couponOn = false; saveCart(); orderDone = true; renderCart();
  const title = nothing ? "That's the full order flow." : paid ? "Payment received. Thank you!" : needsWa ? "One last step: send your order." : "Order placed. Thank you!";
  const lead = nothing ? "Ordering isn't connected yet, so nothing was placed or charged. Add a WhatsApp number or payment key in CONFIG to switch it on."
    : paid ? `We've got your order and your payment. A confirmation is on its way to ${esc(o.customer.email)}.`
    : needsWa ? "WhatsApp should have opened with your order written out. Press send there, and we'll take it from here."
    : `We've got your order and will confirm it by message on ${esc(o.customer.phone)}.`;
  const steps = needsWa ? [
      "Send the WhatsApp message with your order.",
      o.pay === "online" ? "We reply with a secure payment link, usually within a few hours." : "We reply to confirm your order and delivery address.",
      `Your order is dispatched ${CONFIG.dispatch} and arrives in ${CONFIG.delivery}.`]
    : [ "We confirm your order by message.", `It's dispatched ${CONFIG.dispatch}.`, `It arrives in ${CONFIG.delivery}. You'll get a tracking link.` ];
  $("#checkout").innerHTML = `<div class="conf">
    <div class="ring">${icon("i-check")}</div>
    <h1 class="h-section">${title}</h1>
    <p class="muted" style="max-width:34em">${lead}</p>
    ${nothing ? "" : `<div class="conf-ref">Order ${o.ref}<button data-copy="${o.ref}">Copy</button></div>`}
    ${o.wa ? `<div class="conf-cta"><a class="btn btn-wa" href="${o.wa}" target="_blank" rel="noopener">${icon("i-wa")}${needsWa ? "Send order on WhatsApp" : "Send a copy on WhatsApp"}</a></div>` : ""}
    ${nothing ? "" : `<div class="conf-card"><h2>What happens next</h2><ol class="next">${steps.map(s => `<li>${s}</li>`).join("")}</ol></div>`}
    <div class="conf-card"><h2>Order summary</h2>
      ${o.items.map(i => `<div class="sum-rows" style="border:0;margin:0;padding:6px 0 0"><div><span>${i.qty} × ${esc(i.name)}</span><span>${money(i.price * i.qty)}</span></div></div>`).join("")}
      <div class="sum-rows">
        ${o.t.disc ? `<div class="neg"><span>Code ${o.coupon}</span><span>−${money(o.t.disc)}</span></div>` : ""}
        ${o.t.pre ? `<div class="neg"><span>Online payment offer</span><span>−${money(o.t.pre)}</span></div>` : ""}
        <div><span>Shipping</span><span>${o.t.ship ? money(o.t.ship) : "Free"}</span></div>
        <div class="total"><span>Total</span><span>${money(o.total)}</span></div>
      </div>
      <p class="small muted" style="margin-top:12px">${esc(o.customer.name)}, ${esc(o.customer.addr)}, ${esc(o.customer.city)}, ${esc(o.customer.state)} ${esc(o.customer.pin)} · ${o.payLabel}</p>
    </div>
    <div class="conf-cta"><a class="btn btn-line" href="#/shop">Back to the shop</a><a class="btn btn-line" href="#/account">See your orders</a></div>
  </div>`;
  window.scrollTo({ top: 0, behavior: "instant" });
  if (needsWa && userClick) { try { window.open(o.wa, "_blank", "noopener"); } catch(e){} }
}

/* ---------- quick view, lightbox, search ---------- */
function openQuick(id){
  const p = P(id);
  $("#quickBody").innerHTML = `
    <div class="qv-win tone-${p.tone}">${pic(p.img, p.name, p.shade ? 'style="height:250px"' : "")}</div>
    <div class="qv-info">
      <div class="pcard-meta"><span class="chip">${p.spf}</span>${p.size ? `<span>${p.size}</span>` : ""}</div>
      <h2>${p.name}</h2>
      <div class="price">${priceHTML(p)}</div>
      <p class="muted">${p.desc}</p>
      <ul class="benefits small">${p.benefits.slice(0,3).map(b => `<li>${icon("i-check")}<span>${b}</span></li>`).join("")}</ul>
      <div class="buy" style="margin-top:8px"><button class="btn btn-coral" data-add="${id}">Add to bag</button><a class="btn btn-line" href="#/product/${id}" data-close>See details</a></div>
    </div>`;
  $("#quickDlg").showModal();
}
function openLight(src){ $("#lightImg").src = src; $("#lightDlg").showModal(); }
function renderSearch(q=""){
  q = q.trim().toLowerCase();
  const prods = PRODUCTS.filter(p => !q || (p.name + " " + p.tagline + " " + p.badges.join(" ") + " " + p.cat).toLowerCase().includes(q));
  const ings = q ? INGREDIENTS.filter(g => (g.name + " " + g.role).toLowerCase().includes(q)) : [];
  const buns = q ? BUNDLES.filter(b => (b.name + " bundle set").toLowerCase().includes(q)) : [];
  const pols = q ? Object.keys(POLICIES).filter(k => (POLICIES[k].title + " policy").toLowerCase().includes(q)) : [];
  const out = [
    ...prods.map(p => `<a class="tone-${p.tone}" href="#/product/${p.id}" data-close><span class="mini-win">${pic(p.img)}</span><span>${p.name}<small>${p.spf} · ${money(p.price)}</small></span></a>`),
    ...buns.map(b => `<a href="#/shop/bundles" data-close><span class="ring">${icon("i-box")}</span><span>${b.name}<small>Bundle · ${money(b.price)}</small></span></a>`),
    ...ings.map(g => `<a href="#/science" data-close><span class="ring">${icon(g.icon)}</span><span>${g.name}<small>Ingredient · ${g.role}</small></span></a>`),
    ...pols.map(k => `<a href="#/policy/${k}" data-close><span class="ring">${icon("i-note")}</span><span>${POLICIES[k].title}<small>Help</small></span></a>`)
  ];
  $("#searchRes").innerHTML = out.length ? out.join("") : `<p class="search-none">Nothing matches “${esc(q)}”. Try “sunscreen”, “lip” or “ceramide”.</p>`;
}

/* ---------- toast ---------- */
let toastT;
function toast(msg){
  const t = $("#toast"); t.innerHTML = icon("i-check") + `<span>${msg}</span>`; t.classList.add("is-on");
  clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove("is-on"), 2600);
}
function copyText(text, done){
  const ok = () => toast(done);
  if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(ok, () => toast("Couldn't copy. Select the text and copy it instead."));
  else toast("Couldn't copy. Select the text and copy it instead.");
}

/* ---------- hero slider ---------- */
function initHero(){
  const root = $("#hero");
  if (!root) return { go(){}, pause(){} };
  const slides = $$(".slide", root), tabs = $$(".hero-tab", root);
  if (!slides.length) return { go(){}, pause(){} };
  let i = 0;
  root.style.setProperty("--dur", CONFIG.heroSeconds + "s");
  function go(n){
    i = (n + slides.length) % slides.length;
    slides.forEach((s,k) => { s.classList.toggle("is-active", k === i); s.inert = k !== i; });
    tabs.forEach((t,k) => {
      t.classList.remove("is-active"); void t.offsetWidth;
      t.classList.toggle("is-active", k === i);
      t.classList.toggle("is-done", k < i);
      t.setAttribute("aria-selected", k === i);
    });
  }
  tabs.forEach((t,k) => {
    t.addEventListener("click", () => go(k));
    $("i", t).addEventListener("animationend", () => go(i + 1));
  });
  const hp = $("#heroPrev"), hn = $("#heroNext");
  if (hp) hp.addEventListener("click", () => go(i - 1));
  if (hn) hn.addEventListener("click", () => go(i + 1));
  const pause = on => root.classList.toggle("is-paused", on);
  root.addEventListener("mouseenter", () => pause(true));
  root.addEventListener("mouseleave", () => { pause(false); root.style.setProperty("--mx", 0); root.style.setProperty("--my", 0); });
  root.addEventListener("focusin", () => pause(true));
  root.addEventListener("focusout", () => pause(false));
  document.addEventListener("visibilitychange", () => pause(document.hidden));
  root.addEventListener("keydown", e => { if (e.key === "ArrowLeft") go(i - 1); if (e.key === "ArrowRight") go(i + 1); });
  if (canHover && !reduced) root.addEventListener("pointermove", e => {
    const r = root.getBoundingClientRect();
    root.style.setProperty("--mx", ((e.clientX - r.left) / r.width - .5).toFixed(3));
    root.style.setProperty("--my", ((e.clientY - r.top) / r.height - .5).toFixed(3));
  });
  let x0 = null, y0 = null;
  root.addEventListener("touchstart", e => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; pause(true); }, {passive:true});
  root.addEventListener("touchend", e => {
    const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(i + (dx < 0 ? 1 : -1));
    pause(false);
  }, {passive:true});
  go(0);
  $$("#heroShades .shade").forEach(b => b.addEventListener("click", () => {
    const p = P(b.dataset.shade);
    $$("#heroShades .shade").forEach(x => x.classList.toggle("is-on", x === b));
    $("#heroShadeName").textContent = p.shade.name;
    $("#heroLipImg").src = IMG[p.img];
    $("#heroLipAdd").dataset.add = p.id;
    $("#heroLipLink").href = "#/product/" + p.id;
    $("#heroLipPrice").innerHTML = priceHTML(p);
  }));
  return { go, pause, index: el => slides.indexOf(el) };
}
let hero = { go(){}, pause(){} };

/* ---------- motion: reveals, split headings, header, drag ---------- */
const motion = (() => {
  const show = el => { el.classList.add("is-in"); setTimeout(() => el.classList.add("is-done"), 1500); };
  const io = (!reduced && "IntersectionObserver" in window)
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { threshold:.12, rootMargin:"0px 0px -5% 0px" }) : null;
  function split(el){
    const text = el.textContent.trim();
    el.setAttribute("aria-label", text);
    el.innerHTML = text.split(/\s+/).map((w,i) => `<span class="split-w" aria-hidden="true"><span style="--w:${i}">${w}</span></span>`).join(" ");
    el.classList.add("is-split");
  }
  function scan(root=document){
    if (!reduced) $$("[data-split]:not(.is-split)", root).forEach(split);
    $$("[data-rv-stagger]", root).forEach(el => [...el.children].forEach((c,i) => c.style.setProperty("--i", i)));
    $$("[data-rv]:not(.is-in),[data-rv-stagger]:not(.is-in)", root).forEach(el => io ? io.observe(el) : show(el));
  }
  // header: shadow once scrolled; on phones it tucks away on the way down and returns on the way up
  let lastY = 0;
  function onScroll(){
    const y = scrollY, head = $("#head");
    head.classList.toggle("is-stuck", y > 60);
    if (Math.abs(y - lastY) > 8) { head.classList.toggle("is-hidden", y > lastY && y > 320 && !$("dialog[open]")); lastY = y; }
  }
  addEventListener("scroll", onScroll, { passive:true });
  // drag to scroll with a mouse
  function drag(el){
    let down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener("pointerdown", e => { if (e.pointerType !== "mouse") return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
    addEventListener("pointermove", e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 6) { moved = true; el.classList.add("is-drag"); } if (moved) el.scrollLeft = sl - dx; });
    addEventListener("pointerup", () => { if (!down) return; down = false; setTimeout(() => el.classList.remove("is-drag"), 0); });
    el.addEventListener("click", e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener("dragstart", e => e.preventDefault());
  }
  return { scan, drag };
})();

/* ---------- router ---------- */
let current = "home", booted = false;
const PAGES = ["shop","product","routine","about","science","help","policy","account","checkout"];
const TITLES = { account:"Your account — Fléora", home:"Fléora — Glow, protect, nourish", shop:"Shop the range — Fléora", routine:"Find your routine — Fléora", about:"About — Fléora", science:"Our science — Fléora", help:"Help and contact — Fléora", checkout:"Checkout — Fléora" };
const trail = [], spots = new Map();
try { history.scrollRestoration = "manual"; } catch(e){}
function route(){
  if (SHOP) {
    if (/^#\/checkout/.test(location.hash)) {          // checkout is Shopify's, not a page here
      const prev = trail[trail.length - 1];
      history.replaceState(null, "", location.pathname + location.search + (prev || "#/"));
      shopifyCheckout();
      if (prev) return;
    }
    // once the visitor moves on from a store page (/products/..., /pages/...) the address goes back to the home path
    if (booted && location.pathname !== shopRoot && location.hash && !/^#\/policy\/shopify/.test(location.hash))
      history.replaceState(null, "", shopRoot + location.hash);
  }
  const hash = location.hash || "#/";
  const [name="", arg=""] = hash.replace(/^#\/?/, "").split("/");
  const page = PAGES.includes(name) ? name : "home";
  if (SHOP && page === "home" && SHOP.template !== "index" && !$("#page-home").childElementCount) { location.href = shopRoot; return; }
  const same = page === current && page !== "product" && page !== "policy";
  const last = trail[trail.length - 1];
  if (last) spots.set(last, scrollY);
  const back = trail.length > 1 && trail[trail.length - 2] === hash;
  if (back) trail.pop(); else if (last !== hash) trail.push(hash);
  const draw = () => {
    current = page;
    $$(".page").forEach(p => p.classList.toggle("is-active", p.id === "page-" + page));
    $$(".nav-link").forEach(a => a.classList.toggle("is-current", a.dataset.page === page || (page === "product" && a.dataset.page === "shop")));
    document.title = TITLES[page] || TITLES.home;
    if (page === "shop") renderShop(arg || "all");
    if (page === "product") renderProduct(arg);
    if (page === "routine" && !same) { rt = { step: 0, a: [] }; renderRoutine(); }
    if (page === "policy") renderPolicy(arg);
    if (page === "account") renderAccount();
    if (page === "checkout") renderCheckout();
    $$("dialog[open]").forEach(d => d.close());
    $("#head").classList.remove("is-hidden");
    if (!(same && page === "shop")) window.scrollTo({ top: back ? (spots.get(hash) || 0) : 0, behavior: "instant" });
    syncTabbar(); syncWish();
    if (booted) motion.scan($("#page-" + page));
  };
  if (booted && !reduced && document.startViewTransition && !(same && page === "shop")) {
    const vt = document.startViewTransition(draw);
    vt.finished.catch(() => {}).then(() => $$("[style*='view-transition-name']").forEach(e => e.style.viewTransitionName = ""));
  } else draw();
}
/* bottom nav: on the home page it stays hidden until the visitor scrolls off the first view */
function syncTabbar(){
  const bar = $("#tabbar");
  const up = current !== "product" && current !== "checkout" && (current !== "home" || scrollY > 80);
  bar.classList.toggle("is-up", up); bar.inert = !up;
  $$("a", bar).forEach(a => {
    const on = a.dataset.tab === current;
    a.classList.toggle("is-current", on);
    if (on) a.setAttribute("aria-current", "page"); else a.removeAttribute("aria-current");
  });
}
addEventListener("scroll", syncTabbar, {passive:true});
$("#tabbar").addEventListener("click", e => {
  const a = e.target.closest("a"); if (!a) return;
  if (a.dataset.tab === current && (current !== "shop" || location.hash.replace(/\/$/, "") === "#/shop")) { e.preventDefault(); window.scrollTo({top:0, behavior:"smooth"}); }
});
addEventListener("hashchange", route);

/* ---------- events ---------- */
document.addEventListener("click", e => {
  if (SHOP && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
    const a = e.target.closest("a[href]"), raw = a && !a.target ? a.getAttribute("href") : "";
    if (raw && raw.charAt(0) === "/" && raw.charAt(1) !== "/") {
      const path = raw.split(/[?#]/)[0].replace(/\/$/, ""), base = shopRoot.replace(/\/$/, "");
      const rel = path.indexOf(base) === 0 ? path.slice(base.length) : path;
      let to = "";
      const pm = rel.match(/^\/products\/([^/]+)$/);
      if (pm) { const p = P(decodeURIComponent(pm[1])), b = B(decodeURIComponent(pm[1])); to = p ? "#/product/" + p.id : b ? "#/shop/bundles" : ""; }
      else if (/^\/collections(\/all)?$/.test(rel)) to = "#/shop";
      else if (rel === "" && (SHOP.template === "index" || $("#page-home").childElementCount)) to = "#/";
      if (to) { e.preventDefault(); const dl = a.closest("dialog"); if (dl) dl.close(); location.hash = to; return; }
    }
  }
  // the product picture morphs into the product page
  const pl = e.target.closest(".pcard a[href^='#/product/']");
  if (pl && current !== "product") { const im = $(".pcard-win img:not(.pcard-alt)", pl.closest(".pcard")); if (im) im.style.viewTransitionName = "pshot"; }

  const t = e.target.closest("[data-add],[data-buy],[data-quick],[data-open],[data-close],[data-light],[data-life],[data-homecat],[data-ing],[data-qty],[data-cartqty],[data-remove],[data-scroll],[data-shot],[data-coupon-off],[data-wish],[data-swap],[data-copy],[data-rt],[data-rt-back],[data-rt-reset],[data-rt-add],.rit-step h3 button");
  if (e.target.tagName === "DIALOG") {                                    // click on the backdrop
    const r = e.target.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    return;
  }
  if (!t) return;
  const d = t.dataset;
  if (t.matches(".rit-step h3 button")) return ritual.go(+t.closest(".rit-step").dataset.rstep, true);
  if (d.add) {
    e.preventDefault();
    const src = flySource(t), inBag = !!t.closest("#cartDlg");
    if (!add(d.add, d.useqty !== undefined ? pdpQty : 1)) return;
    if (!inBag) { const q = t.closest("dialog"); const run = fly(src); if (q) q.close(); run.then(openCart); }
  }
  if (d.close !== undefined) { const dl = t.closest("dialog"); if (dl) dl.close(); }
  if (d.buy) { if (add(d.buy, pdpQty)) location.hash = "#/checkout"; }
  if (d.quick) openQuick(d.quick);
  if (d.open) {
    $("#" + d.open).showModal();
    if (d.open === "searchDlg") { $("#searchInput").value = ""; renderSearch(); $("#searchInput").focus(); }
  }
  if (d.light) openLight(IMG[d.light]);
  if (d.homecat) renderHomeGrid(d.homecat);
  if (d.ing) renderIng(d.ing);
  if (d.qty) { pdpQty = Math.max(1, pdpQty + +d.qty); $("#pdpQty").textContent = pdpQty; }
  if (d.cartqty) setQty(d.cartqty, +d.d);
  if (d.remove) { delete cart[d.remove]; saveCart(); renderCart(); }
  if (d.couponOff !== undefined) { couponOn = false; saveCart(); renderCart(); }
  if (d.swap) { const b = B(d.swap); b.items.forEach(id => { cart[id]--; if (cart[id] <= 0) delete cart[id]; }); cart[b.id] = (cart[b.id] || 0) + 1; saveCart(); renderCart(); toast(`Switched to ${b.name}`); }
  if (d.wish) {
    const on = !wish.has(d.wish); if (on) wish.add(d.wish); else wish.delete(d.wish);
    store.set("fleora_wish", [...wish]); syncWish();
    t.classList.remove("pop"); void t.offsetWidth; if (on) t.classList.add("pop");
    toast(on ? "Saved for later" : "Removed from saved");
    if (current === "account") renderAccount();
  }
  if (d.copy) copyText(d.copy, "Copied");
  if (d.scroll) { const el = $(d.scroll); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - 70, behavior: "smooth" }); }
  if (d.shot || d.life) {
    $$(".pdp-thumb").forEach(b => b.setAttribute("aria-pressed", b === t));
    const st = $("#pdpStage"), p = P(pdpId);
    st.classList.toggle("is-photo", !d.cut);
    st.innerHTML = d.life ? `<img class="photo" style="object-position:center;cursor:default" src="${photoSrc(d.life, 900, 1100)}" alt="${PHOTOS[d.life].alt}" referrerpolicy="no-referrer">`
      : d.cut ? pic(d.shot, p.name, `class="cut" ${p.shade ? 'style="height:60%;margin-bottom:60px"' : ""}`) : pic(d.shot, p.name, `class="photo" data-light="${d.shot}"`);
  }
  if (d.rt) { rt.a[rt.step] = d.rt; rt.step++; renderRoutine(); window.scrollTo({ top: 0, behavior: "smooth" }); }
  if (d.rtBack !== undefined) { rt.step = Math.max(0, rt.step - 1); renderRoutine(); }
  if (d.rtReset !== undefined) { rt = { step: 0, a: [] }; renderRoutine(); }
  if (d.rtAdd) { const src = flySource(t); d.rtAdd.split(",").forEach(id => add(id, 1)); fly(src).then(openCart); }
});
document.addEventListener("submit", e => {
  const f = e.target, kind = f.dataset.form; if (!kind) return;
  e.preventDefault();
  if (kind === "news") {
    const email = $("#newsEmail").value;
    post(CONFIG.newsletterEndpoint, { email, at: Date.now() });
    if (SHOP && f.getAttribute("action")) fetch(f.getAttribute("action"), { method: "POST", body: new FormData(f), credentials: "same-origin" }).catch(() => {});
    const ok = $("#newsOk"); ok.hidden = false;
    ok.innerHTML = `<span>${CONFIG.newsletterEndpoint ? "You're on the bloom list. Here's" : "Here's"} ${CONFIG.coupon.pct}% off your first order:</span><span class="news-code">${CONFIG.coupon.code}<button type="button" data-copy="${CONFIG.coupon.code}">Copy</button></span>`;
    f.hidden = true;
  }
  if (kind === "contact") {
    const d = Object.fromEntries(new FormData(f));
    if (CONFIG.formEndpoint) { post(CONFIG.formEndpoint, { ...d, at: Date.now() }); toast("Message sent. We'll reply by email."); f.reset(); }
    else if (CONFIG.whatsapp) { window.open(wa(`Hi Fléora, this is ${d.name} (${d.email}).\n\n${d.message}`), "_blank", "noopener"); toast("WhatsApp opened with your message. Press send there."); }
    else { location.href = `mailto:${CONFIG.email}?subject=${encodeURIComponent("Message from " + d.name)}&body=${encodeURIComponent(d.message)}`; }
  }
  if (kind === "me") { store.set("fleora_me", Object.fromEntries(new FormData(f))); toast("Details saved on this device"); }
  if (kind === "coupon") {
    const val = $("#couponIn").value.trim().toUpperCase();
    if (val === CONFIG.coupon.code) { couponOn = true; saveCart(); renderCart(); toast(`${CONFIG.coupon.code} applied`); }
    else toast(val ? `“${esc(val)}” isn't a valid code. Check the spelling and try again.` : "Enter a discount code first");
  }
  if (kind === "checkout") placeOrder(f);
});
document.addEventListener("change", e => {
  if (e.target.id === "shopSort") renderShop((location.hash.split("/")[2]) || "all");
  if (e.target.name === "pay") renderCheckout();
});
document.addEventListener("keydown", e => {
  if (e.key === "/" && !e.target.closest("input,textarea,select") && !$("dialog[open]")) { e.preventDefault(); $("#searchDlg").showModal(); $("#searchInput").value = ""; renderSearch(); $("#searchInput").focus(); }
});
$("#searchInput").addEventListener("input", e => renderSearch(e.target.value));

/* ---------- Shopify: open the right view for the address the visitor arrived on ---------- */
function shopBoot(){
  const box = $("#shopifyContent");
  let target = SHOP.route || "";
  if (target === "content") {
    if (box && box.innerHTML.trim()) {
      // the store's own content (a page, a policy, a blog post) is moved, not copied, so its forms keep working
      shopBox = box;
      POLICIES.shopify = { title: SHOP.title || "", lead: "", body: () => `<div id="shopifyMount"></div>` };
      target = "#/policy/shopify";
    } else target = "";
  }
  if (target.indexOf("#/product/") === 0) {
    const h = target.slice(10), p = PRODUCTS.find(x => x.handle === h || x.id === h), b = BUNDLES.find(x => x.handle === h || x.id === h);
    target = p ? "#/product/" + p.id : b ? "#/shop/bundles" : "#/shop";
  }
  const h = location.hash;
  if (target && (!h || h === "#" || h === "#/"))
    history.replaceState(null, "", (target === "#/policy/shopify" ? location.pathname : shopRoot) + location.search + target);
  const whenReady = fn => { const t = setInterval(() => { if (booted) { clearInterval(t); fn(); } }, 120); };
  if (SHOP.open === "cart") whenReady(openCart);
  if (SHOP.open === "search") whenReady(() => { $("#searchDlg").showModal(); $("#searchInput").value = SHOP.q || ""; renderSearch(SHOP.q || ""); });
  shopifyOrderCheck();
}

/* ---------- Shopify theme editor: keep the preview in step with what the merchant is editing ---------- */
const designMode = !!(window.Shopify && window.Shopify.designMode);
if (designMode) {
  const viewOf = el => { const pg = el.closest(".page"); return pg ? pg.id.replace("page-", "") : ""; };
  const showView = el => {
    const v = viewOf(el); if (!v || v === current) return false;
    location.hash = v === "home" ? "#/" : v === "product" ? "#/product/" + PRODUCTS[0].id : v === "about" ? "#/about" : "#/" + v;
    return true;
  };
  const reveal = el => $$("[data-rv],[data-rv-stagger]", el).forEach(x => x.classList.add("is-in", "is-done"));
  document.addEventListener("shopify:section:load", e => {
    const el = e.target;
    if (el.closest("#page-home")) { renderHome(); ritual.init(); if ($("#hero", el)) hero = initHero(); }
    fillSections(el); motion.scan(el); reveal(el); syncWish();
  });
  document.addEventListener("shopify:section:select", e => {
    const el = e.target, moved = showView(el);
    reveal(el);
    if (moved) setTimeout(() => window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - 90, behavior: "instant" }), 400);
  });
  document.addEventListener("shopify:block:select", e => {
    const slide = e.target.closest ? e.target.closest("#hero .slide") : null;
    if (slide && hero.index) { hero.go(hero.index(slide)); hero.pause(true); }
    const d = e.target.closest ? e.target.closest("details.faq") : null; if (d) d.open = true;
  });
  document.addEventListener("shopify:block:deselect", () => hero.pause(false));
}

/* ---------- start ---------- */
renderStatic();
renderCart();
hero = initHero();
ritual.init();
if (SHOP) shopBoot();
route();

/* loading screen: plays once per visit, then lifts like a curtain */
(() => {
  const pre = $("#pre"), root = document.documentElement;
  let seen = false; try { seen = sessionStorage.getItem("fleora_seen") === "1"; sessionStorage.setItem("fleora_seen", "1"); } catch(e){}
  if (designMode) seen = true;
  if (seen && pre) pre.classList.add("is-quick");
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const heroImgs = $$("#hero .slide.is-active img").map(im => im.decode ? im.decode().catch(() => {}) : Promise.resolve());
  const ready = Promise.all([document.fonts ? document.fonts.ready : null, ...heroImgs, wait(reduced || designMode ? 0 : seen ? 500 : 1900)]);
  Promise.race([ready, wait(4000)]).then(() => {
    if (pre) pre.classList.add("is-done");
    return wait(reduced || !pre ? 0 : 220);
  }).then(() => {
    root.classList.add("is-ready"); booted = true;
    if (pre) { pre.classList.add("is-out"); setTimeout(() => pre.remove(), 1200); }
    motion.scan();
  });
})();
